{
  "AcceptButton": {
    "AbortOption": "Nej",
    "AlternativeButtonLabel": "Spara",
    "ConfirmDeleteQuestion": "Är du säker?",
    "ConfirmOption": "Ja",
    "DefaultButtonLabel": "Acceptera"
  },
  "AddExternalLinkModal": {
    "AddAndClose": "Lägg till och stäng",
    "AddAndNew": "Lägg till och ny",
    "AddLink": "Lägg till länk",
    "Anchor": "Ankare",
    "Auto": "Auto",
    "FullUrlOrId": "Fullständig URL eller #ID",
    "InvalidForm": "Ogiltigt formulär",
    "LinkAdded": "Länk tillagd",
    "NewCommonTab": "Ny gemensam flik",
    "NewTab": "Ny flik",
    "SameTab": "Samma flik",
    "TitleOnUrl": "Titel"
  },
  "AnalyticsView": {
    "Analysis": "Analys",
    "AnalysisTable": {
      "EditorUrl": "Redigerar-URL",
      "PageLocale": "Språkversion",
      "PageStatus": "Sidstatus",
      "PageTitle": "Sidtitel",
      "PortalUrl": "Portal-URL"
    },
    "BlockTypeUsageAnalyzer": {
      "DescriptiveText": "Här kan du se var olika modultyper används på din webbplats. Välj en modultyp från rullgardinsmenyn och klicka på 'Kör analys' för att se resultaten.",
      "RunAnalysisButton": "Kör analys"
    },
    "WhatPagesUseWhatModules": "Vilka sidor använder vilka moduler"
  },
  "ArticleTitleBlock": {
    "Heading": "Rubrik; behöver bara anges om den ska avvika från sidans titel (se sidinställningar)",
    "HideInsertTitle": "Dölj infogad titel",
    "InsertTitle": "Infoga titel",
    "Preamble": "Ingress",
    "SyncPageDescription": "Använd sidbeskrivning som ingress"
  },
  "AttachmentsBlock": {
    "MaxRows": "Max antal rader (innan visa alla-knapp)",
    "SearchFieldText": "Etikett för sökfält i listan",
    "ShowSearchField": "Visa sökfält i listan"
  },
  "BannerBlock": {
    "AddMediaButtons": {
      "addAudio": "Ljudfil",
      "addIcon": "Lägg till ikon",
      "addSvg": "SVG"
    },
    "AddSlideshowImagesDescription": "OBS: Det visas maximalt 5 bilder i bildspelet; huvudbilden och de första 4 eller slumpmässiga ytterligare bilderna.",
    "AddSlideshowImagesRandomizeLabel": "Visa i slumpmässig ordning.",
    "AddSlideshowImagesLabel": "Lägg till fler bilder som bildspel ({{count}})",
    "AdvancedSettings": {
      "dmSearch": {
        "Label": "Inkludera extern sökfunktion från DigitaltMuseum",
        "completeUrl": {
          "HelperText": "Klistra in den fullständiga URL:en efter att du ställt in sökningen i DigitaltMuseum.",
          "Label": "DigitaltMuseum sökkontext (url-kodad)",
          "Placeholder": "Fullständig URL från DM"
        },
        "labelButton": {
          "Label": "Text på sökknappen",
          "Placeholder": "Sök"
        },
        "labelPlaceholder": {
          "Label": "Text i sökfältet",
          "Placeholder": "Sök på DigitaltMuseum.no"
        }
      },
      "effect": {
        "HelperText": "Kan inte kombineras med beta:slides",
        "Label": "Beta: Effekt på bild",
        "options": {
          "": "Ingen effekt",
          "parallax": "Parallax (använd sparsamt)",
          "zoom": "Zooma in",
          "effect-media-contain": "Visa hela bilden alltid",
          "effect-media-contain-on-phone": "Visa hela bilden på mobil stående",
          "effect-media-contain-on-large": "Visa hela bilden på större skärmar (t.ex. desktop)"
        }
      },
      "svgLogo": {
        "HelperText": "SVG-logotyp som alternativ till titel",
        "Label": "SVG-logotyp"
      },
      "tocId": {
        "HelperText": "ID för intern länk",
        "Label": "ID"
      }
    },
    "BannerBlockTextEditor": {
      "recommendationLabel": "Vi rekommenderar att du använder minimalt med text här."
    },
    "BannerBlockTextLineColorSelector": {
      "label": "Textlinjer",
      "line-dark": "Mörk halvt genomskinlig linje",
      "line-light": "Ljus halvt genomskinlig linje"
    },
    "BannerMediaBackground": {
      "Remove": "Ta bort bild",
      "gradient": "Gradient",
      "hideVideoControls": "Dölj videokontroller",
      "label": "Lägg till mediebakgrund",
      "localCaption": "Lokal bildtext",
      "localCaptionDescription": "Åsidosätter global bildtext",
      "mediaCredits": "Mediaupphov",
      "mediaCreditsDescription": "Mediaupphov visas diskret",
      "overlay": "Övertoning",
      "vignette": "Vinjettering",
      "usePosterImage": "Visa affischbild vid uppstart av video",
      "skin": "Färg på vinjett, gradient eller övertoning (om annat än svart)"
    },
    "BannerTitle": {
      "BannerBlockTitleAlignmentSelector": {
        "center": "Centrera",
        "default": "Auto",
        "left": "Vänster",
        "right": "Höger",
        "tooltip": "Textjustering"
      },
      "BannerBlockTitleSizeSelector": {
        "default": "Standard",
        "large": "Stor",
        "medium": "Mellan",
        "normal": "Normal",
        "small": "Liten",
        "tooltip": "Textstorlek",
        "xl": "XL",
        "xxl": "XXL"
      },
      "BannerBlockTitleTransformationSelector": {
        "capitalize": "Stor begynnelsebokstav",
        "lowercase": "Gemener",
        "normal": "Normal",
        "tooltip": "Transformation",
        "uppercase": "Versaler"
      },
      "BannerBlockTitleVerticalAlignmentSelector": {
        "bottom": "Nederkant",
        "default": "Auto",
        "justify": "Justera",
        "middle": "Mitten",
        "tooltip": "Vertikal justering",
        "top": "Överkant"
      },
      "BannerBlockTitleWeightSelector": {
        "black": "Black",
        "bold": "Fet",
        "default": "Auto",
        "extrabold": "Extra fet",
        "light": "Lätt",
        "medium": "Mellan",
        "normal": "Normal",
        "regular": "Reguljär",
        "semibold": "Halvfet",
        "thin": "Tunn",
        "tooltip": "Tyngd på typsnitt"
      },
      "HideTitleLabel": "Dölj titel",
      "RunningHeadLabel": "Löpande rubrik",
      "SetTitleAsH1": "Använd som sidans huvudrubrik (H1)",
      "TitleLabel": "Titel"
    },
    "LinksLabel": "Lenkar/Knappar",
    "CloseSlideshowImagesButton": "Stäng bildspel",
    "MoreSettingsLabel": "Fler inställningar",
    "NextButtonLabel": "Visa pil ner till nästa banner eller avsnitt (t.ex. från top-banner)",
    "VideoBannerExplanation": "Video i en banner används bara som bakgrundseffekt och spelas automatiskt utan ljud, i helskärmsläge, i loop och utan kontroller (paus, helskärm osv.). Om du behöver vanliga videofunktioner ska du istället använda Video-modulen i innehållsavsnittet.",
    "legacySettings": "Använd 'Box'- och 'Textlines'-lägen istället för dessa inställningar",
    "transparent": "Transparent banner (användbart för inledande avsnitt med bakgrundsbilder)",
    "useModuleContentBackgound": "Halvtransparent ruta bakom text",
    "useTextbackgound": "Halvtransparenta textlinjer"
  },
  "ButtonCollection": {
    "ShowLess": "Visa mindre",
    "ShowMore": "Visa mer"
  },
  "BylineBlock": {
    "Author": "Författare",
    "ChoosePerson": "Välj person",
    "Description": "Beskrivning",
    "Employee": "Anställd",
    "FindImage": "Hitta bild",
    "Manual": "Manuellt",
    "Person": "Personkort",
    "PersonCardsNotSupported": "Personkort stöds inte längre. Välj en anställd eller använd manuellt läge",
    "UploadImage": "Ladda upp bild",
    "WrittenBy": "Skriven av"
  },
  "CaptionInput": {
    "CaptionLabel": "Bildtext",
    "HideCaption": "Dölj bildtext"
  },
  "CardEditor": {
    "BothInternalAndExternal": "Både interna och externa länkar är inställda. Den interna länken kommer att användas.",
    "Category": "Välj kortkategori",
    "Description": "Beskrivning (håll den kort!)",
    "EditCard": "Redigera kort",
    "FindImage": "Hitta bild",
    "Footer": "Sidfotstext",
    "FooterLocation": "Plats (text)",
    "ImageFieldTitle": "Välj bild",
    "InternalCard": "Intern länk",
    "NoCategory": "Ingen kategori",
    "Page": "Länk till sida",
    "RemoveImage": "Ta bort bild",
    "RemovePage": "Ta bort sida",
    "SelectPage": "Välj sida",
    "SelectSkin": "Välj färg",
    "SwapImage": "Byt bild",
    "Title": "Titel",
    "Url": "Extern länk",
    "UrlDescription": "Fullständig URL, t.ex. https://museum.no",
    "UrlExternal": "Länk (extern)",
    "callToActionButtonText": "Läs mer-text"
  },
  "CardModuleBlock": {
    "Auto": "Auto",
    "AutoOldSettings": "Inställningar från Museum24 1.0",
    "CardSizeSelector": {
      "collapsed": "Komprimerad",
      "label": "Välj storlek för alla kort",
      "large": "Stor",
      "medium": "Mellan",
      "small": "Liten",
      "undefined": "Ej vald"
    },
    "MediaSizeSelector": {
      "label": "Medieförhållande för alla kort",
      "16-9": "16:9",
      "4-3": "4:3",
      "3-2": "3:2",
      "1-1": "1:1",
      "2-3": "2:3",
      "3-4": "3:4",
      "free": "Fri",
      "undefined": "Ej vald (auto)"
    },
    "GridMobileBehaviourLabel": "Rutnätsbeteende i mobil",
    "ListMobileBehaviourLabel": "Listbeteende i mobil",
    "GridSizeLabel": "Rutnätsstorlek",
    "GroupByLabel": "Gruppering av kort (se resultat i portalen)",
    "Manual": "Manuell",
    "category": "Kategori",
    "events": "Datum",
    "footerLocation": "Plats (text)",
    "footerText": "Sidfotstext",
    "includeGlobalListSearch": "Gör list-sök global",
    "includeListSearch": "Inkludera sökfält för lista",
    "listSearchText": "Text i sökfältet",
    "location": "Plats",
    "metadataformat": "Metadataformat",
    "noMeta": "Dölj metadata/sidfot",
    "place": "Museum",
    "ChangeCard": "Ändra kort (globalt)",
    "ChangesSaved": "Ändringar är sparade. Du måste spara sidan igen för att se ändringarna i förhandsvisningen. I slutportalen kommer de att vara på plats redan."
  },
  "CardModuleBlockCardSearch": {
    "FilterCategories": "Kategorier",
    "FilterTags": "Nyckelord",
    "FooterLink": "Knapp längst ner (länk till fler)",
    "Metadata": "Metadata på korten",
    "Order": "Sorteringsordning",
    "OrderBy": "Sortera efter",
    "OrderBySelector": {
      "date": "Publiceringsdatum",
      "event": "Kalenderdata",
      "false": "Manuell",
      "title": "Alfabetisk: Titel"
    },
    "OrderSelector": {
      "asc": "Stigande",
      "desc": "Fallande"
    },
    "Rows": "Max resultat",
    "Title": "Kort-sökning"
  },
  "CardModuleBlockItem": {
    "GridSizeSelector": {
      "collapsed": "Komprimerad",
      "default": "Ej vald",
      "label": "Välj storlek",
      "large": "Stor",
      "medium": "Mellan",
      "small": "Liten"
    }
  },
  "CardModuleViewTypeSelector": {
    "CardModuleViewTypeVariant": {
      "articles": "Artikellista",
      "auto": "Auto",
      "grid": "Rutnät",
      "horizontal": "Horisontell rullning",
      "list": "Lista",
      "card": "Kort",
      "col-1": "En kolumn på mobil (stående)"
    }
  },
  "CardsView": {
    "BlockType": {
      "article__card": "Kort",
      "article__person": "Personer (avvecklat)"
    },
    "BlockTypeLabel": "Typ:",
    "CategoriesInfo": "*Kortkategorier är de kategorier som fanns i gamla Museum24. En separat inställning har nu skapats för EVENEMANG.",
    "CategoriesInfoLinkText": "Läs mer här.",
    "CategoriesLabel": "Kortkategorier*:",
    "CreateCard": "Skapa nytt kort",
    "Title": "Kort",
    "PersonsInfo": "Använd anställd-galleri och anställd-moduler istället",
    "CardFilter": {
      "unpublished": "Inte publicerade",
      "internal_card": "Interna kort",
      "all": "Alla",
      "external_card": "Externa kort"
    }
  },
  "CommonBlockContent": {
    "Alignment": {
      "Tooltip": "Textjustering",
      "auto": "Auto",
      "center": "Centrera",
      "left": "Vänster",
      "module": "Modul (vänster)"
    },
    "BlockSettings": "Titel och beskrivning",
    "FormLabels": {
      "AnchorID": "Ankare",
      "Body": "Beskrivning"
    }
  },
  "CommonSectionContent": {
    "FormLabels": {
      "AnchorID": "Ankare",
      "Arrows": "Visa pilar",
      "BackgroundMedia": "Mediebakgrund",
      "BackgroundPosition": "Bakgrundsposition",
      "CarouselSettings": "Inställningar för karusellvy",
      "CarouselAutoplay": "Autoplay",
      "CarouselAutoplaySpeed": "Autoplay-hastighet (millisekunder)",
      "CarouselTransition": "Övergångseffekt",
      "CssClass": "CSS-klass",
      "Filter1": "Filter 1",
      "Filter2": "Filter 2",
      "MediaCredits": "Bildtext/Fotograf/Licens",
      "MobileBehavior": "Mobilbeteende",
      "MobileBehaviorDescription": "Normalt vises två små moduler i bredden på mobil, övriga storlekar visas i en kolumn.",
      "Modifier": "Rutnätsstorlek",
      "ModifierDescription": "Normal vises 4 små moduler i bredden på större skjermer. Här kan du ändra på detta.",
      "PaddingBottom": "Utrymme nedanför",
      "PaddingTop": "Utrymme ovanför",
      "Spacing": "Utrymme mellan banderoller",
      "TextColor": "Textfärg",
      "Title": "Titel",
      "ToggleIntrosection": "Aktivera Scrollytell-sektion",
      "ToggleVisibleTitle": "Visa titel",
      "ToggleCenterTitle": "Centrera titel",
      "RemoveLeftPadding": "Ta bort vänstermarginal på banderoller (för vänsterjusterad text)"
    },
    "SectionSettings": "Sektionsinställningar",
    "arrows": {
      "allways": "Alltid",
      "first": "Endast på första modulen",
      "none": "Aldrig"
    },
    "backgroundPosition": {
      "center": "Centrera",
      "contain": "Anpassa",
      "top": "Överst"
    },
    "filter": {
      "animation-zoom": "Zoom-animering",
      "filter-blur": "Oskärpa",
      "filter-blur-2": "Oskärpa 1",
      "filter-blur-3": "Oskärpa 2",
      "filter-blur-5": "Oskärpa 3",
      "filter-blur-10": "Oskärpa 4",
      "filter-blur-15": "Oskärpa 5",
      "filter-blur-20": "Oskärpa 6",
      "filter-blur-30": "Oskärpa 7",
      "filter-blur-50": "Oskärpa 8",
      "filter-brightness": "Ljusstyrka",
      "filter-brightness-04": "Ljusstyrka 1",
      "filter-brightness-05": "Ljusstyrka 2",
      "filter-brightness-06": "Ljusstyrka 3",
      "filter-brightness-07": "Ljusstyrka 4",
      "filter-brightness-08": "Ljusstyrka 5",
      "filter-contrast": "Kontrast",
      "filter-contrast-05": "Kontrast 1",
      "filter-contrast-08": "Kontrast 2",
      "filter-grayscale": "Gråskala",
      "filter-grayscale-03": "Gråskala 1",
      "filter-grayscale-05": "Gråskala 2",
      "filter-grayscale-08": "Gråskala 3",
      "filter-sepia": "Sepia",
      "filter-sepia-05": "Sepia 1",
      "filter-sepia-08": "Sepia 2"
    },
    "mobileBehavior": {
      "auto": "Auto (2 kolumner)",
      "col-1": "En kolumn på mobil (stående)"
    },
    "modifier": {
      "auto": "Auto (4 kolumner)",
      "grid33": "3 kolumner (en kolumn på mobil)"
    },
    "padding": {
      "0": "0",
      "1": "1",
      "2": "2",
      "3": "3",
      "4": "4",
      "5": "5",
      "6": "6",
      "10": "10",
      "auto": "Auto"
    },
    "spacing": {
      "0": "Ingen",
      "1": "Mellanrum",
      "2": "Mellanrum",
      "auto": "Auto",
      "line": "Linje"
    },
    "textColor": {
      "dark": "Mörk",
      "light": "Ljus"
    },
    "transition": {
      "fade": "Fade",
      "slide": "Slide"
    }
  },
  "ContentView": {
    "backToEventsButtonLabel": "Tillbaka till evenemangen",
    "backToPageTreeButtonLabel": "Tillbaka till sidträdet",
    "eventsTitle": "Evenemang",
    "importedPagesButtonLabel": "Importerade sidor",
    "importedPagesDeleteStopped": "{{done}} av {{total}} sidor raderades. Resten finns kvar i listan.",
    "importedPagesDeleted": "{{count}} sida/sidor raderade",
    "importedPagesPublished": "{{count}} sida/sidor har publicerats och placerats i sidträdet",
    "openImportedPagesHere": "Öppna här",
    "openImportedPagesInNewWindow": "Öppna i nytt fönster",
    "pagesTitle": "Sidor"
  },
  "CreatePageModal": {
    "CreateEventFailed": "Kunde inte skapa evenemang",
    "CreateEventSuccessful": "Evenemang skapades",
    "CreateNewEvent": "Skapa nytt evenemang",
    "CreateNewPage": "Skapa ny sida",
    "CreateNewTemplate": "Skapa ny mall",
    "CreatePageFailed": "Kunde inte skapa sidan",
    "CreatePageSuccessful": "Sidan skapades",
    "CreateTemplateFailed": "Kunde inte skapa mall",
    "CreateTemplateSuccessful": "Mallen skapades",
    "EventTitle": "Evenemangstitel",
    "InvalidForm": "Ogiltigt formulär",
    "NewEvent": "Nytt evenemang",
    "NewPage": "Ny sida",
    "NewTemplate": "Ny mall",
    "NoSiteId": "Ingen plats-ID",
    "PageTitle": "Sidtitel",
    "Path": "Sökväg",
    "PathAlreadyExists": "Sökvägen finns redan",
    "PathReservedForLanguage": "Denna url-sökväg är reserverad för språkversioner av webbplatsen.",
    "PathExample": "(t.ex. museum.no/en för engelska m.m.)",
    "Under": "Under",
    "UnsavedChangesWarning": "Du har osparade ändringar! Dessa ändringar kommer att gå förlorade om du fortsätter.",
    "save_and_close": "Spara och stäng",
    "save_and_create_new": "Spara och ny",
    "save_and_edit": "Spara och redigera"
  },
  "CurrentPageInfo": {
    "ShowingXToYOutOfZItems_one": "Visar {{from, number}} - {{to, number}} av {{count, number}} objekt",
    "ShowingXToYOutOfZItems_other": "Visar {{from, number}} - {{to, number}} av {{count, number}} objekt"
  },
  "DMBlock": {
    "AddFilteringSortingForUsers": "Lägg till filtrering/sortering för användare",
    "AltDescriptionLabel": "Alternativ beskrivning",
    "AltTitleLabel": "Alternativ titel",
    "AlternativeFields": "Fyll i alternativ text",
    "DigitalResources": "Digitala resurser",
    "DMItemsLabel": "Välj objekt från DM",
    "DMMuseumLabel": "Välj ett museum från DM",
    "DMLinkLabel": "Knapp under listan med valfri länk till DigitaltMuseum",
    "DmLink": "Fullständig URL för knappen Gå till DigitaltMuseum",
    "DmLinkText": "Text på DigitaltMuseum-knappen",
    "EnableSearch": "Visa sökruta för att söka på DigitaltMuseum",
    "EndUserFilteringSorting": {
      "gradeFilter": "Årskurs",
      "subjectFilter": "Ämne",
      "ownerFilter": "Museum",
      "resourceTypeFilter": "Resurstyp",
      "sortBySelector": "Sorteringstyp",
      "orderSelector": "Sorteringsordning",
      "queryFilter": "Fritextsökning"
    },
    "HasPictures": "Endast objekt med bild",
    "LicenseTypesLabel": "Filtrera efter licenstyper",
    "MaxItemsLabel": "Antal objekt att visa",
    "NoImages": "Objektet saknar bilder",
    "SearchConfig": "Sõkeregler",
    "ObjectTypesLabel": "Filtrera efter DM-objekttyper",
    "OrderBySelector": {
      "Label": "Sortering",
      "options": {
        "score": "Relevans",
        "relevance": "Relevans",
        "last_updated": "Senast uppdaterad",
        "published_at": "Publiceringsdatum"
      }
    },
    "OrderSelector": {
      "Label": "Sorteringsordning",
      "options": {
        "asc": "A-Ö",
        "desc": "Ö-A"
      }
    },
    "OwnerCodesLabel": "Lista med ägarkoder",
    "OwnerCodeSelectOne": "Välj minst en ägarkod",
    "PaginateMaxItemsLabel": "Knapp för att ladda fler objekt",
    "PhysicalResources": "Fysiska resurser (besök på museet)",
    "PreviewFilterInfo": "Filter för slutanvändare är aktiverat. Se resultat i portalen",
    "QueryLabel": "Fritextsökning i listan",
    "RemoveObject": "Ta bort valt objekt",
    "School": {
      "Grades": {
        "SelectGrade": "Välj klassnivå",
        "Options": {
          "kindergarten": "Förskola",
          "grade_two": "Åk 1 till 2",
          "grade_four": "Åk 3 till 4",
          "grade_seven": "Åk 5 till 7",
          "grade_ten": "Åk 8 till 10",
          "vg_one": "Gymnasiet åk 1",
          "vg_two": "Gymnasiet åk 2",
          "vg_three": "Gymnasiet åk 3"
        }
      },
      "SelectAtLeastOneOwner": "Välj minst ett museum",
      "Subject": {
        "SelectSubject": "Välj ämne",
        "Options": {
          "SocialStudies": "Samhällskunskap",
          "Science": "Naturkunskap",
          "Norwegian": "Norska",
          "DramaAndRhythmics": "Drama och rytmik",
          "ReligionEthicsLifeStance": "Religion, etik och livsåskådning",
          "ArtsAndCrafts": "Bild och form",
          "FoodAndHealth": "Mat och hälsa",
          "Music": "Musik"
        }
      }
    },
    "SelectMainPicture": "Välj vilken bild som ska visas",
    "Show": "Visa",
    "ShowSchoolTypes": "Skoltyper (alla visas som standard)",
    "SubjectsLabel": "Kommaseparerad lista med ämnen",
    "UseOwnerCodes": "Filtrera efter DM-ägare",
    "VisitTheMuseums": "Besök museerna",
    "VRItemsLabel": "Välj virtuella upplevelser från DM",
    "WideDisplayLabel": "Använd en bredare stil"
  },
  "DMFilterSearch": {
    "FreeTextSearch": "Fritextsökning",
    "FreeTextSearchTitleLabel": "Sökeord",
    "FreeTextSearchDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "IncludeFreeTextSearchLabel": "Inkludera fritextsökning (sökningen görs inom de parametrar som valts ovan)",
    "InputLabelProducers": "Tillverkare (kommaseparerade)",
    "InputLabelMaterials": "Material (kommaseparerade)",
    "InputLabelSubjectKeywords": "Ämnesord (kommaseparerade)",
    "InputLabelTechnique": "Teknik (kommaseparerade)",
    "ItemsRestriction": "Absolute restriction",
    "KulturNavTitleLabel": "KulturNav-post",
    "LicenseTypesLabel": "DM-licenstyper",
    "LicenseTypesDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "LicenseTypesTitleLabel": "Licenser",
    "LimitTitleLabel": "Antal objekt att visa",
    "Producers": "Tillverkare",
    "ProducersDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "ProducersTitleLabel": "Tillverkare",
    "MaterialsDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "MaterialsTitleLabel": "Materialer",
    "MuseumsCollectionsTitleLabel": "Museer/samlingar",
    "NoAccessMessage": "Den här komponenten är satt upp av ansatte i KulturIT. Var god och ta kontakt om du vill byta ut.",
    "ObjectTypesTitleLabel": "Objekttyper",
    "ObjectTypesDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "ObjectTypesSelectInputLabel": "DM-objekttyper",
    "OwnerCodesDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "OwnerCodesLabel": "Lista över ägarkoder",
    "ShowInSameTab": "Visa i samma fane (ved klikk på DM kort)",
    "ShowOnlyObjectsWithImage": "Visa endast objekt med bild",
    "SubjectKeywordsFilter": "Filtrering med ämnesord",
    "SubjectKeywordsDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "SubjectKeywordsTitleLabel": "Ämnesord",
    "TechniqueDropDownMenuTitleLabel": "Rullgardinsmenyens titel",
    "TechniqueTitleLabel": "Teknik",
    "Time": "Tid",
    "TimeSliderTitle": "Titel ovanför reglaget",
    "TimeTitleLabel": "Tid",
    "TimeYearFrom": "År från",
    "TimeYearTo": "År till",
    "UserFiltrationOnWebsite": "Användarfiltrering på webbplatsen"
  },
  "DMFinderHeader": {
    "FilterLabel": "Filtrera DM-sökning",
    "HasLocation": "..koordinater",
    "HasPictures": "Har bilder",
    "HasVideo": "..video",
    "HasAudio": "..ljud",
    "ObjectType": "Objekttyp",
    "OnlyOurOwnerCode": "Endast vår ägarkod ({{ownerCode}})",
    "OnlyOurOwnerCodes": "..ägarkoder",
    "Owner": "Ägare"
  },
  "DMHeader": {
    "LicenseLabel": "Licens:",
    "OwnerLabel": "Ägare:"
  },
  "DMImagePicker": {
    "Cancel": "Avbryt",
    "Confirm_one": "Använd {{count}} bild",
    "Confirm_other": "Använd {{count}} bilder",
    "ImageLabel": "Bild {{number}}",
    "InfoTextMultiple": "Objektet har flera bilder. Välj en eller flera.",
    "InfoTextSingle": "Objektet har flera bilder. Välj en.",
    "NoImages": "Inga bilder hittades på objektet."
  },
  "DMViewTypeSelector": {
    "grid": "Rutnät",
    "list": "Lista",
    "simple": "Länkar med pil (ingen bild)",
    "map": "Karta"
  },
  "DashboardView": {
    "BottomBanner": {
      "GetStarted": "Kom igång med M24",
      "Heading": "Hur man använder Museum24",
      "KeywordIndex": "Nyckelordsindex",
      "Text": "Funktioner, byggblock och exempel",
      "TipsAndInspiration": "Tips och inspiration",
      "UserManual": "Gå till webbplats"
    },
    "ContentWidget": {
      "EventsTitle": "Evenemang",
      "LastEdited": "Senast ändrad",
      "PagesTitle": "Innehåll"
    },
    "CountResLabel": {
      "archived": "Arkiverad",
      "audio": "Ljud",
      "document": "Dokument",
      "draft": "Utkast",
      "image": "Bilder",
      "in_use": "I bruk",
      "published": "Publicerad",
      "total": "Totalt",
      "video": "Video"
    },
    "EventsLabel": "Evenemang",
    "FormsLabel": "Formulär",
    "FormsWidget": {
      "Title": "Formulär"
    },
    "MediaLabel": "Media",
    "MediaWidget": {
      "DAMSIntegrationEnabled": "DAMS-integrasjon aktivert",
      "Title": "Media"
    },
    "MessagesWidget": {
      "Title": "Meddelanden från museum24"
    },
    "PagesLabel": "Sidor",
    "SettingsShortcutWidget": {
      "ChangeFooter": "Ändra sidfot",
      "ChangeMenu": "Ändra toppmeny"
    },
    "SharingWidget": {
      "AccessGiven": "Delning med andra webbplatser",
      "AccessGranted": "Åtkomst beviljad till andra webbplatser",
      "NewRequests": "Du har nya förfrågningar",
      "NoNewRequests": "Inga nya förfrågningar",
      "NoSharing": "Ingen delning",
      "Title": "Åtkomst/delning"
    },
    "ReindexPagesWidget": {
      "Title": "Sökindex",
      "IncludeAllSites": "Inkludera alla webbplatser",
      "Reindex": "Bygg om index",
      "Reindexing": "Bygger om index...",
      "ReindexSuccess": "Indexering slutförd",
      "ReindexFailed": "Misslyckades att bygga om index: {{error}}"
    },
    "WelcomeBannerWidget": {
      "DescriptionLabel": "Beskrivning av webbplats",
      "ImageLabel": "Webbplatsens huvudbild",
      "NoDescription": "– Ingen beskrivning (lägg till under försidans metainställningar)",
      "NoFavicon": "– Ingen favicon (lägg till favicon (och touchicon) under webbplatsens inställningar)",
      "NoImage": "– Ingen huvudbild (lägg till under försidans metainställningar)",
      "NoDescriptionOrImage": "Beskrivning och huvudbild läggs till under försidans metainställningar."
    }
  },
  "DatelineBlock": {
    "Dateline": "Dateline",
    "DatelineDescription": "Visar publiceringsdatum, och klockslag om du vill. Den kan också visa när innehållet senast ändrades.",
    "LabelLastModifiedText": "Text före senast ändrad",
    "LabelPublishedDate": "Publiceringsdatum",
    "LabelShowLastModified": "Visa senast ändrad datum",
    "LabelShowTime": "Visa klockslag (för båda datumen)",
    "LabelText": "Text före publiceringsdatum",
    "LastModifiedDefaultText": "Senast ändrad",
    "Metadata": "Metadata",
    "MetadataDescription": "Metadata används inte längre i version 2.0. För att lägga till evenemang, använd evenemangsmodulen.",
    "ShowLastModifiedHelp": "Visas bara när det är ett annat datum än publiceringsdatumet, eller ett annat klockslag när klockslag visas."
  },
  "DeleteButton": {
    "AbortOption": "Nej",
    "AlternativeButtonLabel": "Ta bort",
    "ConfirmDeleteQuestion": "Är du säker?",
    "ConfirmOption": "Ja",
    "DefaultButtonLabel": "Radera"
  },
  "EditSelectedMedia": {
    "ConfirmUpdateSelection": "Är du säker på att du vill uppdatera alla valda objekt?"
  },
  "EditorBreadcrumbItem": {
    "ChildrenLabel": "Undersidor",
    "CreateChildPage": "Skapa undersida",
    "EditLinkLabel": "Redigera {{title}}",
    "NoChildren": "Inga undersidor"
  },
  "EditorHeader": {
    "CreateEvent": "Skapa nytt evenemang",
    "CreatePage": {
      "ActionMenuLabel": "Skapa ny sida",
      "Child": "Under denna sida",
      "Sibling": "På samma nivå"
    },
    "GoBack": "Gå tillbaka",
    "ImportedPlaceHint": "Importerad sida. ”Spara och publicera” publicerar den och lägger den i roten av sidträdet.",
    "LastUpdatedAt": "Senast uppdaterad {{at}}",
    "PublishedAt": "Publicerad {{timestamp}}",
    "TemplateTooltip": "Detta är en mall och är inte tillgänglig i portalen",
    "pageSettings": "Sidinställningar",
    "pageTemplateSettings": "Inställningar för mall"
  },
  "EditorPreviewContainer": {
    "FlipDeviceOrientation": "Vrid enhetens orientering",
    "PreviewType": {
      "auto": "Auto",
      "desktop": "Dator",
      "desktop_4k": "Dator (4K)",
      "developer": "Utvecklare",
      "fill": "Fyll",
      "mobile": "Mobil",
      "tablet": "Surfplatta"
    },
    "ShowInPortal": "Visa nuvarande publicerade version i portalen"
  },
  "EditorSectionActionButton": {
    "Tooltip": "Åtgärder"
  },
  "EkulturCallbackHandler": {
    "errors": {
      "missingCodeOrState": "Saknar information för att slutföra inloggningen",
      "swapForTokenFailed": "Ett fel uppstod. Kunde inte logga in"
    },
    "loggingIn": "Loggar in..."
  },
  "EkulturLoginController": {
    "LoadingUser": "Kontrollerar användare...",
    "LoggedInAsUser": "Inloggad som: {{user}}",
    "NoAccess": "Du har inte åtkomst till denna app. Kontakta din eKultur-administratör för åtkomst."
  },
  "EkulturLogoutHandler": {
    "logOutNow": "Logga ut nu",
    "loggingOut": "Loggar ut...",
    "loggingOutInXSec_one": "Du loggas ut om 1 sekund...",
    "loggingOutInXSec_other": "Du loggas ut om {{count}} sekunder...",
    "logoutFailed": "Ett fel uppstod vid utloggning"
  },
  "EmployeeEditor": {
    "AddExternal": "Lägg till extern länk",
    "AddPage": "Lägg till sidlänk",
    "ChangePage": "Byt sida",
    "ContactFieldsTitle": "Kontaktuppgifter",
    "Department": "Avdelning",
    "Description": "Beskrivning / fritext",
    "Email": "E-postadress",
    "FindImage": "Välj bild",
    "Firstname": "Förnamn",
    "ImageFieldTitle": "Bild och fokuspunkt",
    "InvalidUrl": "Ogiltigt URL-format",
    "Lastname": "Efternamn",
    "LinkName": "Länkens namn",
    "LinksFieldTitle": "Länkar",
    "Page": "Sida",
    "PageLinkTitle": "Sidlänk",
    "PageLinkAbout": "Denna länk kommer att visas på anställdkortet och leda till en sida på webbplatsen. Sidan måste skapas först och kan innehålla mer information om den anställde, till exempel en forskningsprofil, projekt eller liknande. Länken kommer också att användas i Byline-modulen.",
    "PageLinkExternalAbout": "Denna/ dessa länkar kommer att visas på anställdkortet och leda till angiven URL. Översta länken kommer också att användas i Byline-modulen om ingen intern sidlänk ovan är angiven.",
    "Phone": "Telefonnummer",
    "Position": "Titel/befattning",
    "RemoveImage": "Ta bort bild",
    "RemoveLink": "Ta bort länk",
    "RemovePage": "Ta bort sida",
    "RequiredFieldsMissing": "Följande obligatoriska fält saknas: {{fields}}",
    "SaveFailed": "Ett fel inträffade vid sparande: {{error}}",
    "SaveSuccess": "Anställd sparad",
    "SelectPage": "Välj sida",
    "SwapImage": "Byt bild",
    "TextFieldsTitle": "Personuppgifter",
    "UrlExternal": "Extern URL"
  },
  "EmployeesBlock": {
    "EnableSearch": "Visa sökruta",
    "SearchTypeLabel": "Typ av sökruta",
    "SearchTypeOptions": {
      "local": "Lokal: Filtrering av anställda i denna modul",
      "page": "Sida: Filtrering av anställda i alla moduler på denna sida",
      "site": "Söksida: Går till en standard sida för att söka efter anställda"
    },
    "EnableEmployeeSiteSearch": "Visa sökruta för att söka efter anställda via webbplatsens sökfunktion",
    "SelectInfoToShow": "Välj vilka fält som ska visas",
    "ShowDepartment": "Avdelning",
    "ShowDescription": "Beskrivning",
    "ShowEmail": "E-post",
    "ShowLinks": "Länkar",
    "ShowPhone": "Telefonnummer",
    "ShowPosition": "Titel/befattning",
    "ShowSite": "Museum"
  },
  "EmployeesView": {
    "AddEmployee": "Lägg till anställd",
    "HeaderCount": "Visar {{count}} av {{total}} anställda",
    "Title": "Anställda"
  },
  "EmployeesViewTypeSelector": {
    "grid": "Rutnät",
    "list": "Lista"
  },
  "EventData": {
    "AddTime": "Lägg till ny tid",
    "CategoryTitle": "Kategori: Evenemang",
    "Title": "Evenemangstitel ( = sidtitel)",
    "Description": "Beskrivning av evenemang",
    "EndTime": "Sluttid",
    "FreeText": "Fri text",
    "InvalidUrl": "Ogiltig URL (https://...)",
    "Location": "Plats för evenemanget",
    "LocationText": "Oregistrerad platsinfo",
    "LocationTooltip": "Dessa platser är tillagda i din webbplatsinställning",
    "ShowAsOneCardPerDateRow": "Visa som ett kort per datumrad",
    "SkinLabel": "Välj färg för listning",
    "StartTime": "Starttid",
    "SubCategoryInfo": "Du behöver inte välja några underkategorier om det inte behövs för vidare specificering eller filtrering av evenemangstyp.",
    "SubCategoryLabel": "Välj underkategorier för evenemang",
    "TicketText": "Text på biljettknappen",
    "TicketUrl": "URL-länk för biljetter",
    "TimeInfoLabel": "Ytterligare tidsinformation",
    "UseEndDateLabel": "Inkludera sluttid",
    "UseRangeLabel": "Definiera en tidsperiod",
    "UseTimeLabel": "Inkludera klockslag",
    "Weekdays": "Vardagar",
    "EnableStructuredMarkup": "Markera som 'Google event'"
  },
  "EventsBlock": {
    "CategoriesFilteringLabel": "Evenemangskategorier",
    "DateFilteringLabel": "Datum",
    "DisableExpandedDates": "Expandera aldrig kort",
    "DisplayOptions": {
      "Category": "Evenemangskategorier",
      "Description": "Beskrivning",
      "Location": "Plats",
      "Museum": "Museum (webbplats)"
    },
    "EventsLabel": "Evenemang",
    "NoEventsSelected": "Inga evenemang er tillagda.",
    "FinderButton": "Välj evenemang",
    "LocationFilteringLabel": "Platser",
    "MaxItemsLabel": "Max antal objekt",
    "MuseumFilteringLabel": "Museer",
    "PreviewFilterInfo": "Evenemangsfilter är aktiverat. Se resultat i portalen",
    "Rules": "Regler för sökning",
    "ShowAllLinkPageButtonLabel": "Välj sida",
    "ShowAllLinkPageTitle": "Länk till \"Visa fler\"",
    "ShowAllLinkType": {
      "button": "Knapp",
      "text": "Textlänk"
    },
    "ShowAllLinkTypeLabel": "Visa länk som",
    "ShowForPeriodLabel": "Visa för period",
    "ShowForPeriodType": {
      "1m": "1 månad",
      "3m": "3 månader",
      "6m": "6 månader",
      "12m": "12 månader",
      "previous": "Tidigare",
      "specify": "Ange period",
      "today": "Dagens"
    },
    "TargetGroupsFilteringLabel": "Målgrupper",
    "TodayFilteringLabel": "Idag",
    "UseFilteringLabel": "Filtrera efter",
    "UseLocationFiltering": "Platser",
    "UseMuseumFiltering": "Museer",
    "UserFilteringLabel": "Lägg till filtrering/sortering för slutanvändaren av listan",
    "EnableSearchLabel": "Visa sökruta",
    "OrderFilteringLabel": "Sorteringsordning"
  },
  "FavouriteButton": {
    "MarkAsFavourite": "Markera som favorit",
    "UnmarkAsFavourite": "Avmarkera som favorit"
  },
  "FilterMenu": {
    "FilterMenuTooltip": "Filtrera sidor",
    "sections": {
      "MainCategories": "Huvudkategorier",
      "Statuses": "Statusar",
      "SubCategories": "Underkategorier"
    }
  },
  "Finder": {
    "CardTitle": "Kort",
    "EventsTitle": "Evenemang",
    "Filter": {
      "CardType": "Korttyper",
      "IncludeMediaTypes": "Mediatyper",
      "OnlyOwnerContent": "Endast tillagt av Ägare: {{ownerName}}",
      "OnlyUserContent": "Endast tillagt av mig",
      "ShowContentFrom": "Visa innehåll från..."
    },
    "FinderSource": {
      "digitalt_museum": "Digitalt Museum",
      "e_kultur": "eKultur",
      "favourites": "Favoriter",
      "museum_24": "Museum 24"
    },
    "MediaTitle": "Mediagalleri",
    "MediaTitleDams": "DAMS galleri",
    "PageTitle": "Sidor",
    "Search": "Sök efter innehåll...",
    "SelectMuseum": "Välj museum",
    "SelectDamsGallery": "Välj DAMS-galleri",
    "TemplatesTitle": "Mallar",
    "UseSelected_interval": "(0)[Inga element valda];",
    "UseSelected_one": "Använd vald",
    "UseSelected_other": "Använd valda ({{count}})"
  },
  "FinderButton": {
    "card": "Lägg till ett kort",
    "dams": "Välj fil från DAMS",
    "digitaltMuseum": "Välj fil från DigitaltMuseum",
    "employee": "Lägg till anställd(a)",
    "form": "Lägg till ett formulär",
    "icon": "Lägg till en ikon",
    "kp": "Lägg till objekt från KulturPunkt",
    "kp_owner": "Lägg till ett Kulturio-museum",
    "m24": "Välj fil eller ladda upp från mediagalleri",
    "m24_images_video": "Välj bilder eller videor från mediagalleri",
    "m24_images": "Välj bilder från mediagalleri",
    "owner": "Lägg till ett museum"
  },
  "FolderView": {
    "ConfirmDeleteFolderDialogHtml": "<p>Är du säker på att du vill ta bort mappen <strong>{{folderName}}</strong>?</p><p>Alla undermappar tas bort, och alla sidor flyttas ut ur mappar.</p>",
    "DeleteActionButton": "Ta bort",
    "MoveActionButton": "Flytta till...",
    "MoveDialogTitle": "Flytta till mapp",
    "cancel": "Avbryt",
    "confirmMoveButton": "Flytta",
    "createNewFolder": "Skapa mapp",
    "createdAtDate": "Skapad {{date}}",
    "editName": "Redigera namn",
    "folderItemCount": "{{ count }} evenemang",
    "newFolderDefaultName": "Ny mapp",
    "rootFolderName": "Evenemang",
    "newFolderNameLabel": "Mappnamn",
    "createAndClose": "Lägg till",
    "createAndNew": "Lägg till och ny",
    "closeDialog": "Avbryt"
  },
  "FormEditor": {
    "AddBlockType": "+ {{blockType}}",
    "AddSection": "+ sektion",
    "Address": {
      "AddressLabel": "Adressetikett",
      "CountryCodeLabel": "Landskodsetikett",
      "PostalCodeLabel": "Postkodsetikett",
      "PostalPlaceLabel": "Postortsetikett",
      "StateLabel": "Delstatsetikett"
    },
    "AttachmentsSizeLimit": "Begränsa filstorlek",
    "BlockType": {
      "button": "Knapp",
      "checkbox": "Ja/Nej",
      "content": "Innehåll",
      "input": "Inmatning",
      "options": "Alternativ",
      "user": "Användare/Adress"
    },
    "InternalLabel": "Intern etikett",
    "ButtonLabel": "Knapptext",
    "EmailReceiver": "E-postmottagare",
    "FieldSettings": "Inställningar för detta fält",
    "FormInvalidLabel": "Text för ogiltigt formulär",
    "InUseByPages": "Används av sidor",
    "InputLabel": "Etikett för inmatning",
    "NewForm": "Nytt formulär",
    "Preview": {
      "DefaultFileButtonLabel": "Hämta fil",
      "DefaultFileLabel": "Filuppladdning",
      "button": {
        "default": "Skicka",
        "next": "Nästa",
        "prev": "Föregående",
        "reset": "Återställ"
      }
    },
    "SectionInputs": "Fält",
    "SectionReceipt": "Bekräftelse",
    "SendEmailOnSubmissions": "Skicka e-post vid inlämningar",
    "button": {
      "defaultBlockLabel": "Skicka",
      "nextBlockLabel": "Nästa",
      "prevBlockLabel": "Föregående",
      "prev_nextBlockLabel": "Föregående/Nästa",
      "resetBlockLabel": "Återställ"
    },
    "input": {
      "FirstNameLabel": "Etikett för förnamn",
      "LastNameLabel": "Etikett för efternamn",
      "ShowImagePreview": "Visa förhandsgranskning",
      "addressBlockLabel": "Adress",
      "dateBlockLabel": "Datum",
      "emailBlockLabel": "E-post",
      "fileBlockLabel": "Filuppladdning",
      "nameBlockLabel": "Namn",
      "textBlockLabel": "Text (enrad)",
      "textareaBlockLabel": "Text (flera rader)"
    },
    "options": {
      "AddAlternative": "Lägg till alternativ",
      "Horizontal": "Horisonale val",
      "OptionN": "Alternativ {{n}}",
      "PreSelected": "Förvald",
      "checkboxBlockLabel": "Flera val",
      "radioBlockLabel": "Ett val"
    },
    "user": {
      "Address2Enabled": "Inkludera adressrad 2",
      "CompleteAddressEnabled": "Inkludera fullständig adress (för ytterligare info)",
      "ConfirmEmail": "Användaren måste bekräfta e-post",
      "CountryCodeEnabled": "Inkludera landskod",
      "Description": "Fälten \"förnamn\", \"efternamn\" och \"e-post\" är alltid obligatoriska",
      "EmailConfirmLabel": "Etikett för e-postbekräftelse",
      "EmailLabel": "Etikett för e-post",
      "FirstnameLabel": "Etikett för förnamn",
      "LastnameLabel": "Etikett för efternamn",
      "PhoneLabel": "Etikett för telefon",
      "StateEnabled": "Inkludera delstat",
      "completeBlockLabel": "Fullständig",
      "minimumBlockLabel": "Minsta",
      "simpleBlockLabel": "Enkel"
    }
  },
  "FormView": {
    "BackToOverview": "< Tillbaka till formuläroversikt",
    "CreateNewForm": "Skapa nytt formulär",
    "DeleteAll": "Ta bort alla",
    "DeleteData": "Ta bort data",
    "DeleteIndividual": "Ta bort individuell",
    "EditForm": "Redigera formulär",
    "ExportData": "Exportera data",
    "FormData": "Formulärsdata",
    "FormDeletedFailed": "Ett fel uppstod när formuläret skulle tas bort: {{error}}",
    "FormDeletedSuccess": "Formuläret togs bort",
    "NoItems": "Inga formulär hittades",
    "NumberOfPagesInUse": "Antal sidor i bruk: {{count}}",
    "OlderThanX": "Äldre än {{days}} dagar",
    "ShowAnswers": "Visa svar ({{count}})",
    "Title": "Formulär"
  },
  "GoogleMapsAutoComplete": {
    "AddLocationLabel": "Sök efter en plats",
    "NoOptionsText": "Inga träffar"
  },
  "GridViewDMVariant": {
    "License": "Licens",
    "Owner": "Ägare",
    "Pictures": "Bilder"
  },
  "ImageWithFocusPointSelector": {
    "SelectFocusPoint": "Välj fokuspunkt för {{imageName}}",
    "SelectFocusPointDescription": "Välj fokuspunkt"
  },
  "KPBlock": {
    "AdditionalPointsTooltip": "Dessa KulturPunkt-artiklar visas utöver eventuella underartiklar eller urval från en presentation ovan",
    "BigViewLabel": "Stor vy",
    "displayDescription": "Vis beskrivning",
    "DisplayOptionsModuleLabel": "Visningsinnställningar för denna modul",
    "DisplayOptionsItemLabel": "Visningsinnställningar för elementene",
    "IntegratedView": "Integrerad vy",
    "IntegratedViewLabel": "Öppna innehållet i en integrerad vy istället för på KulturPunkt.org",
    "JustBanner": "Visa endast banner",
    "KPArticlesLabel": "Välj KulturPunkt-artiklar",
    "KPOwnersLabel": "Välj museer från Kulturio",
    "KPPresentationLabel": "Välj en KulturPunkt-presentation",
    "KPPresentationsLabel": "Välj KulturPunkt-presentationer",
    "ListArticles": "Visa KulturPunkt-artiklar",
    "ListArticlesLabel": "Lista underartiklar",
    "ListPresLabel": "Lista under-presentationer",
    "ListPresentations": "Visa presentationer",
    "MapSettings": "Kartinställningar",
    "NoBackground": "Ingen bakgrundsfärg (genomskinlig)",
    "PickSelectionLabel": "Välj ett urval",
    "PickSubArticlesLabel": "Välj underartiklar",
    "PresChildrenLabel": "Välj KulturPunkt-artiklar från denna presentation",
    "whiteBackground": "Vit bakgrund",
    "disableEkulturMapPin": "Använd standard kartpinne"
  },
  "KPFinderHeader": {
    "FilterByOwner": "Visa endast objekt som tillhör din egen Kulturio-ägare",
    "KPOwnerHeader": "Museer",
    "KPSchemaType": {
      "2": "KulturPunkt-artiklar",
      "12": "KulturPunkt-presentationer",
      "13": "Kulturio Kiosk-vyer",
      "14": "Kulturio Kiosk-enheter"
    }
  },
  "LicenseSelector": {
    "SelectLicense": "Välj licens"
  },
  "LinkListBlock": {
    "AdvancedSettings": {
      "GroupBy": {
        "Label": "Gruppering av länkar",
        "alpha": "Alfabetisk",
        "false": "Ingen"
      },
      "OrderBy": {
        "Label": "Automatisk sortering av länkar",
        "_date": "Datum (publicerat)",
        "_title": "Alfabetisk (titel)",
        "false": "Manuell"
      },
      "Title": "Avancerade inställningar",
      "reverseOrder": "Omvänd ordning",
      "showDate": "Visa publiceringsdatum"
    }
  },
  "LinkListItem": {
    "Anchor": "Ankare",
    "ChangeFile": "Byt fil",
    "File": "Fil",
    "OpeningRule": "Öppningsregel",
    "Target": {
      "_blank": "Ny flik",
      "_self": "Samma flik",
      "auto": "Auto",
      "m24ref": "Ny gemensam flik"
    },
    "Url": "URL"
  },
  "Links": {
    "LinkButtons": {
      "document": "Länk till dokument",
      "event": "Länk till evenemang",
      "link": "Länk (intern/extern)",
      "page": "Länk till sida"
    },
    "LinkExternal": "Extern länk",
    "LinkInternal": "Intern länk",
    "LinkListBelowBodytext": "Länklista under brödtext",
    "ListChildren": "Lista alla undersidor till denna sida",
    "Options": {
      "button": "Knappar",
      "list": "Textlänkar",
      "arrow_list": "Länkar med pil",
      "module": "Hela modulen klickbar"
    },
    "SelectLinkStyle": "Visa länkar som",
    "TitleOverLinkList": "Titel över länklista"
  },
  "ListCardsForPage": {
    "Title": "Kort som pekar till denna sida"
  },
  "LocationSelector": {
    "InputLabel": "Plats"
  },
  "M24Content": {
    "CaptionHint": "Skriv din egen bildtext här om den globala inte passar",
    "EditGlobalMediaData": "Redigera global mediadata i mediagalleriet",
    "MissingAltTextWarning": "Alternativ text saknas",
    "ForcePortraitMode": "Tvinga videovisning till portrettformat",
    "HideZoomButton": "Dölj zoom-knapp"
  },
  "M24PageFinder": {
    "M24PageFinderHeader": {
      "ShowDraft": "Visa utkast"
    }
  },
  "MainMenu": {
    "analytics": "Analys",
    "cards": "Kort",
    "content": "Innehåll / Sidträd",
    "dashboard": "Översikt",
    "employees": "Anställda",
    "events": "Evenemang",
    "forms": "Formulär",
    "media": "Mediagalleri",
    "settings": {
      "cardCategories": "Kortkategorier",
      "categories": "Kategorier",
      "keywords": "Nyckelord",
      "language": {
        "create": "Lägg till nytt språk",
        "title": "SpråkInställningar"
      },
      "locations": "Platser",
      "pageTemplates": "Mallar",
      "sharing": "Åtkomst och delning",
      "site": "Inställningar",
      "users": "Användare",
      "webpage": "Allmänt",
      "owner": "Ägarstruktur"
    },
    "styles": "Färger och stylesheet",
    "stylesDescription": "Du kan klicka på webbplatsikonen i headern eller lenken nedan för att se hur stilarna ser ut i portalen."
  },
  "Manual": {
    "article__card": "https://manual.museum24.no/faktakort",
    "article__openinghours": "https://manual.museum24.no/apningstider",
    "article__person": "https://manual.museum24.no/person",
    "article__sharing": "https://manual.museum24.no/deleknapper",
    "calendar": "https://manual.museum24.no/kalender",
    "calendar__navigator": "https://manual.museum24.no/kalender",
    "digitaltMuseum": "https://manual.museum24.no/overgang-fra-gammel-til-ny",
    "kulturpunkt": "https://manual.museum24.no/overgang-fra-gammel-til-ny",
    "search": "https://manual.museum24.no/sokeresultat"
  },
  "MapV2Block": {
    "AddLocation": "Lägg till plats",
    "InfoBoxHtml": "<p><em>Det här är en ny och förenklad kartmodul. Visning av KulturPunkt och DigitaltMuseum på kartor hanteras nu enkelt i deras egna dedikerade moduler.<em></p><p><em><a href=\"https://manual.museum24.no/kart\">Mer om dessa moduler här</a></em></p>",
    "InfoBoxZoom": "Kartvyn zoomar in automatiskt baserat på punkterna, så att alla punkter visas. Om flera punkter ligger nära varandra grupperas dessa (clustering), vilka visas enskilt när användaren zoomar in.",
    "MapDesign": {
      "black_white": "Svartvitt",
      "label": "Kartstil",
      "normal": "Normal"
    },
    "MapType": {
      "ROADMAP": "Vägkarta",
      "SATELLITE": "Satellit",
      "label": "Typ"
    },
    "addSiteLocationHelpText": "Registrerade platser från inställningar som visas på kartan.",
    "addSiteLocationLabel": "Välj registrerade platser",
    "enableMapTypeHelperText": "Låt användaren välja karttyp",
    "enableMapTypeLabel": "Aktivera val av karttyp",
    "enableStreetViewHelperText": "Låt användaren aktivera Google Street View i kartan",
    "enableStreetViewLabel": "Aktivera Street View",
    "enableWayfinderLabel": "Aktivera vägbeskrivning",
    "enableWayfinderLabelHelperText": "Visa en knapp som låter användaren starta vägbeskrivning till destinationen"
  },
  "MapV2MarkerFormField": {
    "missingTitle": "Plats utan namn"
  },
  "MediaBlock": {
    "AudioVideoContentMessage": "För VIDEO och LJUD finns det nu egna moduler. Flytta gärna detta innehåll till en av dessa moduler, för bättre visning och mer relevanta redigeringsmöjligheter.",
    "CompareTwoImages": "Nästa två bilder jämförs",
    "ColumnSizeLabel": "Kolumnstorlek (på större skärmar)",
    "ColumnSizeHelperText": "Kom ihåg att du också kan välja modulens bredd högst upp.",
    "EnableZoomButton": "Gör bilder klickbara (visa stor version av bilden)",
    "ExternalContentMessage": "För extern VIDEO och LJUD finns det nu egna moduler. Flytta gärna detta innehåll till en av dessa moduler, för bättre visning och mer relevanta redigeringsmöjligheter.",
    "DisableCaptions": "Dölj bildtexter på alla bilder (visas i fullskärmsvy)",
    "Layout": {
      "Auto": "Auto fyllning (bild fyller ramen)",
      "Frame": "Visa hela bilden (ramen fylls av modulens bakgrundsfärg/skin)"
    },
    "MissingImageToCompare": "Saknar bild att jämföra. Välj en nedan.",
    "ShowCaptions": "Visa bildtexter",
    "ShowCaptionsInFullScreen": "Visa bildtexter i helskärmsvy",
    "ShowCaptionsUnderThumbnails": "Visa bildtexter under miniatyrer",
    "SizeLabel": {
      "default": "Liten",
      "large": "Stor",
      "medium": "Mellan"
    }
  },
  "MediaEditor": {
    "AltText": "Alternativ text",
    "Caption": "Beskrivning",
    "CreditName": "Upphovsnamn",
    "CreditType": "Upphovstyp",
    "DAMS": "DAMS information",
    "DAMSInfo": "Denna mediaresurs är kopplad till ett DAMS-objekt. Här är lite information från DAMS-systemet om detta objekt.",
    "DAMSProducers": "Producent/Fotograf",
    "DAMSSubjects": "Ämnen",
    "DAMSPlaces": "Platser",
    "DAMSLicenses": "Lisens",
    "DownloadFile": "Ladda ner fil",
    "HideEditLocales": "Dölj textfält för andra språk",
    "ImageCaption": "Bildtext",
    "InUseLinksLabel": "Denna mediaresurs används på följande platser:",
    "LicenseAndCredits": "Licens och upphov",
    "LicenseType": "Licenstyp",
    "OpenInNewTab": "Öppna filen i ny flik",
    "SaveSuccess": "Media sparades",
    "SelectLicense": "Välj licens",
    "ShowEditLocales": "Visa textfält för andra språk än norska",
    "TagsInfo": "Lägg till taggar för enklare navigering och sökning av media",
    "TagsLabel": "Välj eller lägg till ny tagg...",
    "TextFieldsTitle": "Titel, beskrivning och alternativ text",
    "Title": "",
    "pickPoster": "Välj plakat/cover",
    "removePoster": "Fjern plakat/cover"
  },
  "MediaList": {
    "NoItems": "Inga objekt"
  },
  "MediaView": {
    "AltTextMissingOnMedia": "{{count}} mediaobjekt saknar alternativ text",
    "ConfirmBatchDelete": "Är du säker på att du vill ta bort alla valda objekt?",
    "ConfirmBatchRemove": "Är du säker på att du vill ta bort alla valda objekt?",
    "ConfirmDelete": "Är du säker på att du vill ta bort objektet?",
    "ConfirmRemove": "Är du säker på att du vill ta bort objektet?",
    "Created_at": "Uppladdad",
    "Created_by": "Uppladdad av",
    "CreditTypes": {
      "artist": "Konstnär",
      "author": "Författare",
      "owner": "Ägare",
      "photographer": "Fotograf",
      "voice": "Röst",
      "illustrator": "Illustratör",
      "movie": "Film"
    },
    "Delete_selected": "Radera valda",
    "Remove_selected": "Ta bort valda",
    "EditSelectedMedia": "Redigera valda mediaobjekt",
    "EditState": {
      "group_remove": "Ta bort flera",
      "group_delete": "Ta bort flera",
      "group_update": "Uppdatera flera",
      "single": "Välj ett"
    },
    "Filename": "Filnamn",
    "Filetype": "Filtyp",
    "FilterMissingAlt": "Endast media utan alternativ text",
    "ShowDamsObjects": "Visa DAMS-objekt",
    "InUse": "Används i {{pages}} sidor, {{cards}} kort, {{persons}} personer och {{others}} andra platser",
    "License": "Licens",
    "ListView": {
      "Action": "Åtgärd",
      "Details": "Detaljer",
      "Media": "Media"
    },
    "MediaId": "M24 media-ID",
    "MediaUpdated": "{{nr}} mediaobjekt uppdaterades",
    "MediaUpload": {
      "Header": "Ladda upp mediafiler",
      "Upload": "Ladda upp",
      "HelpText": "Klicka för att välja mediafiler eller dra filer hit",
      "UploadsFailed": "{{failed}} av {{total}} kunde inte laddas upp",
      "FilesUploaded": "{{files}} filer laddades upp",
      "OneUploaded": "Filen laddades upp",
      "ConfirmLeaveEditStage": "Är du klar med att redigera de uppladdade filerna?",
      "InvalidFilesRemoved": "{{count}} ogiltiga eller dubblettfiler togs bort från urvalet",
      "UploadFiles": "Ladda upp filer",
      "AddMetadata": "Lägg till metadata",
      "AddToGallery": "Lägg till i galleri"
    },
    "MissingAlt": "Alternativ text saknas",
    "NotInUse": "Används inte någonstans",
    "NrSelected": "{{nr}} valda",
    "Tags": "Taggar",
    "Title": "Media",
    "Update_selected": "Uppdatera valda",
    "Updated_at": "Uppdaterad",
    "UpdatesFailed": "{{failed}} av {{total}} objekt uppdaterades inte",
    "UploadMedia": "Ladda upp media"
  },
  "MediaViewTypeSelector": {
    "MediaViewTypeVariant": {
      "compareTwoImages": "Jämför",
      "grid": "Bildgalleri",
      "grid__packery": "Bildgalleri (auto)",
      "list": "Normal / Kolumner",
      "slideshow": "Bildspel"
    }
  },
  "Migration": {
    "Cards": {
      "SectionHelpText": "<p>Kort skapas och redigeras nu ENDAST under \"Kort\", på samma sätt som \"Anställda\". Kategorisystemet från den gamla lösningen är fortfarande kopplat till kort, medan det nya integrerade kategorisystemet används för \"Sidlistning\" och \"Evenemang\"</p><p><a href=\"#todo\">Mer om dessa förändringar här.</a></p>"
    },
    "Persons": {
      "CardBlock": "<p>Personer (anställda) finns nu under \"Anställda\" i Museum24 2.0 och kan listas med modulen Anställda i den nya lista-sektionen</p>",
      "PersonBlock": "<p>Personer (anställda) finns nu som Anställda i Museum24 2.0</p>"
    },
    "article__card": "<p>Faktakort stöds inte längre i Museum24 2.0. Använd textmodul eller evenemangsbeskrivningar istället</p>",
    "article__openinghours": "<p><strong>Moduler för öppettider kan ersättas med en textmodul i box-läge.</strong></p>",
    "article__person": "<p><strong>Personmoduler som visats direkt på en sida eller via kortmoduler ersätts av anställda och anställd-moduler, om personerna är anställda</strong></p>",
    "article__sharing": "<p>Ingen alternativ lösning tillgänglig just nu.</p>",
    "calendar": "<p>Denna modul ersätts av nya moduler i den nya lista-sektionen</p>",
    "calendar__navigator": "<p>Denna modul ersätts av nya moduler i den nya lista-sektionen</p>",
    "digitaltMuseum": "<p>Denna modul ersätts av nya moduler i den nya lista-sektionen</p>",
    "intro": "Denna modul är föråldrad i Museum24 2.0",
    "kulturpunkt": "<p>Denna modul ersätts av nya moduler i den nya lista-sektionen</p>",
    "preview": "Ingen förhandsgranskning av denna modul i Museum24 2.0",
    "readMore": "Läs mer på: ",
    "search": "<p><strong>Sökfunktionen kommer att ersättas av en ny standardlösning</strong></p>"
  },
  "PageBlockArticleTitleBlockTextAlignSetting": {
    "Tooltip": "Textjustering",
    "options": {
      "auto": "Auto",
      "center": "Centrera",
      "left": "Vänster"
    }
  },
  "PageBlockAttachmentViewSetting": {
    "ViewTypeVariant": {
      "grid": "Rutnät",
      "list": "Lista"
    },
    "ViewTypeWidth": {
      "none": "Normal",
      "normal": "Normal",
      "wide": "Bred"
    }
  },
  "PageBlockBannerLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "box": "Textbox",
      "default": "Variabel höjd",
      "img": "Text på bild",
      "img-bottom": "Bild under",
      "img-left": "Bild vänster",
      "img-right": "Bild höger",
      "img-top": "Bild överst",
      "img-top no-margin": "Bild överst, ingen marginal",
      "special": "Speciell",
      "textlines": "Textlines"
    }
  },
  "PageBlockBannerSizeSetting": {
    "Tooltip": "Storlek",
    "options": {
      "l": "l",
      "l-m": "l-m",
      "m": "m",
      "m-s": "m-s",
      "s": "s",
      "s-m": "s-m",
      "xl": "xl"
    }
  },
  "PageBlockCollapsibleStateSetting": {
    "Tooltip": "Öppen/stängd",
    "options": {
      "collapsed": "Komprimerad",
      "expanded": "Utökad",
      "semi": "Delvis"
    }
  },
  "PageBlockLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "auto": "Auto",
      "full": "Full",
      "fullWidth": "Helskärm",
      "img-left": "Bild vänster",
      "img-right": "Bild höger",
      "normal": "Normal",
      "wide": "Bred"
    }
  },
  "PageBlockLinkListViewSetting": {
    "Tooltip": "Visningsläge",
    "options": {
      "list": "Enkel lista",
      "teasers": "Teaser-lista"
    }
  },
  "PageBlockModuleLayoutSetting": {
    "Tooltip": "Module-läge",
    "options": {
      "auto": "Auto (bild ovanför text)",
      "img-landscape": "Liggande bild",
      "img-portrait": "Stående bild",
      "left": "Vänster",
      "list": "Lista",
      "right": "Höger",
      "img": "Bild bakom text"
    }
  },
  "PageBlockModuleTypeSetting": {
    "Tooltip": "Modultyp",
    "options": {
      "bodytext": "Text",
      "inline": "Text",
      "module": "Textruta med bakgrund"
    }
  },
  "PageBlockPageListLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "img": "Text på bild",
      "img-top": "Bild överst",
      "img-top no-margin": "Bild överst, utan marginal",
      "list": "Lista",
      "textlines": "Textlines"
    }
  },
  "PageBlockPositionSetting": {
    "Tooltip": "Position",
    "options": {
      "full": "Full",
      "left": "Vänster",
      "normal": "Standard",
      "right": "Höger",
      "wide": "Bred"
    }
  },
  "PageBlockTextPositionSetting": {
    "Tooltip": "Textjustering",
    "options": {
      "left": "Vänster",
      "normal": "Centrera",
      "right": "Höger",
      "wide": "Bred"
    }
  },
  "PageBlockTextSizeSetting": {
    "Tooltip": "Textstorlek",
    "options": {
      "h-large": "Stor",
      "h-medium": "Mellan",
      "h-normal": "Normal",
      "h-xl": "XL"
    }
  },
  "PageEditor": {
    "mergeWithNextSectionConfirm": "Modulerna i sektionen nedanför flyttas in längst ned i den här sektionen, och sektionen nedanför tas bort. Den här sektionens titel och inställningar behålls.",
    "DeleteDraftConfirm": "Är du säker på att du vill ta bort utkastet?",
    "missingEventDateWarning": "Tidsangivelse saknas",
    "missingMainHeadingWarning": "Den vanliga sidrubriken visas inte på den här sidan. Välj då i den översta bannern att rubriken där ska vara sidans huvudrubrik (H1).",
    "newTemplateConfirmDialog": {
      "cancel": "Nej, fortsätt redigera denna sida",
      "navigateToTemplate": "Ja, gå till mallen",
      "prompt": "En ny mall skapades under Inställningar > Mallar. Vill du gå till mallen nu?"
    }
  },
  "PageFolderAutocomplete": {
    "NoFolder": "Ingen mapp"
  },
  "PageListAutoBlock": {
    "Adjustments": "Andra inställningar",
    "Categories": {
      "MainLabel": "Huvudkategori",
      "SubLabel": "Underkategorier"
    },
    "ChoosePage": "Välj sida",
    "ChoosePageCurrentPage": "Välj denna sida",
    "Highlight": "Markera alla",
    "MaxSearchResultsSelector": {
      "Label": "Max antal",
      "options": {
        "undefined": "Auto"
      }
    },
    "Textlines": "Textlines",
    "OrderBySelector": {
      "Label": "Sortering",
      "options": {
        "published_at": "Publiceringsdatum",
        "title": "Alfabetisk",
        "undefined": "Auto"
      }
    },
    "OrderSelector": {
      "Label": "Sorteringsordning",
      "options": {
        "asc": "Stigande",
        "desc": "Fallande",
        "undefined": "Auto"
      }
    },
    "PageTreeButtonLabel": "Välj från sidträdet",
    "RemoveLeftPadding": "Ta bort vänstermarginal i banners",
    "SearchLevel": {
      "children": "Alla undersidor under vald sida",
      "siblings": "Alla sidor på samma nivå"
    },
    "SearchPath": {
      "Label": "Vald sida",
      "NoSelection": "Ej vald"
    },
    "SelectCategoryButtonLabel": "Välj kategori",
    "SitesLabel": "Museer",
    "ThreeCols": "Trekolumners rutnät"
  },
  "PageListManualBlock": {
    "DisplayInputs": {
      "Label": "Visa",
      "displayCategory": "Sidkategori",
      "displayDescription": "Sidbeskrivning",
      "displayInsertTitle": "Infogad titel",
      "displayLocation": "Plats",
      "displayMuseum": "Museum (webbplats)",
      "displayPosition": "Position",
      "displayPublishedDate": "Publiceringsdatum"
    },
    "FilteringOptions": "Filteringsalternativer for sluttbruker",
    "PageListManualBlockItemContent": {
      "DescriptionHelperText": "Lägg till en kort inledning om du vill",
      "Highlight": "Markera denna länk",
      "ImageTopPosition": "Justera bild till toppen",
      "TitleHelperText": "Skriv din egen rubrik här om standardrubriken inte passar"
    },
    "PagesLabel": "Sidor",
    "NoPagesSelected": "Inga sidor är tillagda. Klicka på knappen nedan för att lägga till sidor.",
    "SelectPages": "Välj sidor"
  },
  "EventListViewTypeSelector": {
    "grid": "Rutnät",
    "list": "Lista"
  },
  "EventListLayouts": {
    "img-top": "Bild överst",
    "img-top no-margin": "Bild överst, utan marginaler/skuggor"
  },
  "PageListViewTypeSelector": {
    "grid": "Rutnät",
    "list": "Lista (kort)",
    "simple": "Länkar (titlar)"
  },
  "PageMetadata": {
    "EventNotAllowed": {
      "children": "En sida med undersidor kan inte vara ett evenemang.",
      "frontpage": "Startsidan kan inte vara ett evenemang."
    },
    "MainCategoryLabel": "Välj huvudkategori",
    "SubCategoriesLabel": "Välj underkategorier",
    "description": "Sidbeskrivning",
    "mainImageDescription": "Huvudbilden är den bild som automatiskt kopplas till sidan när man använder kartor och länklistor i Museum24. Även Facebook använder denna bild.",
    "mainImageMissingInfotext": "Om ingen huvudbild är vald, används en slumpmässig bild från sidan (om flera är tillagda).",
    "metaTitle": "SEO: Anpassad sidtitel",
    "metadescription": "SEO: Beskrivning (meta-tag)",
    "pageMainImage": "Huvudbild för sidan:",
    "selectImageHeading": "Välj bild från:",
    "syncPageDescription": "Sätt sidbeskrivningen till samma som ingress"
  },
  "PageSettings": {
    "CancelEditPath": "Återgå till: \"{{old}}\"",
    "Category": "Kategori",
    "CategoryNew": "Kategori (ny)",
    "CategoryOld": "Kategori (gammal)",
    "Close": "Stäng sidinställningar",
    "CloseTemplateSettings": "Stäng mallinställningar",
    "ConfirmApplyTemplate": "Genom att använda en mall skriver du över det nuvarande sidinnehållet. Är du säker på att du vill fortsätta?",
    "EnableEditPath": "Redigera sökväg",
    "FormLabels": {
      "IsLongread": "Använd enkla rubriker för lång artikel (Longread)",
      "Slug": "Slug",
      "Title": "Sidtitel",
      "accessCode": "Åtkomstkod",
      "pageAlreadyHasAccessCode": "Den här sidan har redan en åtkomstkod. Om du anger en ny kod kommer den gamla inte längre att fungera.",
      "isProtected": "Användaren måste ange en kod för att öppna sidan",
      "protectedButton": "Skyddad sida: Text på inloggningsknapp",
      "protectedError": "Skyddad sida: Felmeddelande (fel kod)",
      "protectedIntro": "Skyddad sida: Kort inledning",
      "protectedLabel": "Skyddad sida: Text över kodinmatningsfält",
      "protectedTitle": "Skyddad sida: Rubrik i inloggningsfönster"
    },
    "LockedByParentInfo": "Den här sidan är låst eftersom en föräldrasida är låst. Du kan lägga till en extra åtkomstkod för den här sidan nedan.",
    "Locations": "Platser",
    "LongreadLogoLink": "Logolänk",
    "LongreadLogoText": "Logotyp (text)",
    "PublishDateTip": "TIPA: Du kan också ställa in en framtida publiceringsdatum för att automatiskt publicera sidan vid det datumet.",
    "PublishDateTipLearnMore": "Lär mer om tidsinställd publicering här.",
    "PublishDateTipDescription": "Publiceringsdatum styr när sidan räknas som publicerad. Om sidan publiceras och detta datum är i framtiden, kommer sidan inte att vara synlig för allmänheten förrän det datumet inträffar. Detta gör det möjligt att ställa in tidsinställd publicering, där du kan förbereda en sida och ställa in den för automatisk publicering vid ett senare tillfälle.",
    "RevisionsTable": {
      "CreatedBy": "Sparad av: Namn (Användar-ID)",
      "CreatedByName": "Namn",
      "Current": "gällande",
      "EditedVersion": "Version {{number}} \"{{title}}\" ({{status}})",
      "InfoText": "Här är de 10 föregående sparningarna av den version av sidan som du arbetar med nu.",
      "InfoTextWithCurrent": "Här är de 10 senaste sparningarna av den version av sidan som du arbetar med nu. Den översta är gällande.",
      "RevisionID": "Revisions-ID",
      "SavedTimestamp": "Sparad",
      "Title": "Titel",
      "Version": "Version",
      "VersionID": "Versions-ID"
    },
    "Sections": {
      "formData": "Formulärsdata",
      "general": "Allmänna inställningar",
      "languageConnections": "Språkanslutningar",
      "newsletters": "Nyhetsbrev",
      "revisions": "Revisioner",
      "security": "Säkerhet",
      "versions": "Versioner"
    },
    "SelectTemplateLabel": "Mall",
    "SelectTemplateButton": "Välj mall",
    "SelectTemplateDisabled": "Du måste först spara sidan som en ny versjon/utkast innan du kan använda en mall",
    "SelectTemplateDescription": "Här kan du sätta innehåll från en \"mall\". En mall är en sida med en komplett uppsättning sektioner och moduler, men utan innehåll (text, media osv.).",
    "VersionsTable": {
      "Choosen": "Vald (redigeras just nu)",
      "Count_one": "{{count}} version",
      "Count_other": "{{count}} versioner",
      "Created": "Skapad",
      "CreatedBy": "Skapad av: Namn (Användar-ID)",
      "Current": "Gällande",
      "InfoText": "Detta är en översikt över alla versioner som skapats av denna sida. I Museum24 2.0 skapas en ny version varje gång ett nytt utkast sparas av en sida som redan är publicerad. Redaktionellt arbete kan endast göras på den gällande versionen och utkast som är nyare än den. Versioner som är äldre än den gällande versionen visas som \"Ersatt\".",
      "No": "Nej",
      "OptVersionTitle": "Valfri titel på version",
      "Superseded": "Ersatt",
      "VersionID": "Versions-ID",
      "VersionStatus": "Versionsstatus",
      "Yes": "Ja"
    },
    "LanguageConnections": {
      "Intro": "Här kan du lägga till eller ta bort kopplingar mellan sidor på webbplatsens huvudspråk och motsvarande sidor på andra språk. Detta kommer att aktivera språkvalet i slutportalen för att ge direkta länkar mellan motsvarande sidor på olika språk. Kopplingarna kommer att vara tvåvägs. Om inga kopplingar anges kommer språkvalet i slutportalen alltid att länka till annat språks startsida.",
      "IntroNotMainLanguage": "Kopplingar mellan sidor på olika språk kan endast hanteras via sidor som är på webbplatsens huvudspråk.",
      "ConnectPage": "Anslut till sida",
      "RemoveConnection": "Ta bort koppling",
      "CurrentPageLanguage": "Den här sidans språk",
      "MainLanguage": "Huvudspråk",
      "NoConnection": "Ingen koppling",
      "OtherLanguages": "Andra språk",
      "PageConnections": "Den här sidan är kopplad med:",
      "ConnectedTo": "Kopplad till: {{languages}}"
    },
    "Restore": {
      "Button": "Återställ",
      "ConfirmText": "Vill du återställa innehållet från {{source}}? En ny version (utkast) skapas med detta innehåll, och den måste publiceras för att bli synlig. Fält på sidnivå, som adress, sidtitel och huvudbild, behåller sina nuvarande värden.",
      "DraftExists": "Sidan har redan ett utkast. Publicera eller radera utkastet innan du återställer.",
      "Failed": "Kunde inte återställa innehållet.",
      "RenameFailed": "En ny version skapades, men versionstiteln kunde inte sättas.",
      "RevisionLabel": "revision {{id}} ({{time}})",
      "Success": "Innehållet har återställts i en ny version.",
      "UnsavedChanges": "Du har osparade ändringar. Spara eller ignorera dem innan du återställer.",
      "VersionLabel": "version {{number}}",
      "VersionTitle": "Återställd från {{source}}"
    },
    "Protected": "Skyddad",
    "ProtectedByParent": "Skyddad av överordnad sida"
  },
  "PageSizeSelector": {
    "NumberOfElementsToShow": "Antal element att visa"
  },
  "PageTree": {
    "NoImportedPages": "Inga importerade sidor väntar på placering",
    "NoPagesFound": "Inga sidor hittades"
  },
  "PageTreeActionMenu": {
    "DeleteWithChildrenQuestion": "Undersidorna till den här sidan raderas också. Är du säker?",
    "MenuItems": {
      "Archive": "Arkivera",
      "DeletePage": "Radera",
      "MoveToFolder": "Flytta till mapp...",
      "Preview": "Förhandsgranska",
      "Publish": "Publicera",
      "PublishWithChildren": "Publicera med undersidor",
      "ShowInPortal": "Visa i portal",
      "Unpublish": "Avpublicera"
    }
  },
  "PageTreeBulkOperations": {
    "archive": "Arkivera",
    "delete": "Radera",
    "deleteImportedChildrenNote": "Undersidor till markerade sidor raderas också.",
    "deleteImportedQuestion": "Markerade sidor raderas. Är du säker?",
    "deleteImportedTitle": "Raderar importerade sidor",
    "deleteImportedHint": "Stäng inte fönstret förrän raderingen är klar.",
    "deleteImportedProgress": "Raderar {{done}} av {{total}} sidor …",
    "moveEvents": "Flytta evenemang",
    "movePages": "Flytta sidor",
    "publish": "Publicera",
    "publishImportedChildrenNote": "Undersidor till markerade sidor publiceras också.",
    "publishImportedQuestion": "Markerade sidor publiceras och placeras i roten av sidträdet. Fortsätt?",
    "unpublish": "Avpublicera"
  },
  "PageTreeCheckbox": {
    "Tooltips": {
      "HasChildren": "Tryck SHIFT + KLICK för att välja/avmarkera alla undersidor",
      "NotSelectedAndPartiallySelectedChildren": "Denna sida är INTE vald, men vissa undersidor är valda. $t(PageTreeCheckbox.Tooltips.HasChildren)",
      "SelectedAndPartiallySelectedChildren": "Denna sida och några av dess undersidor är valda. $t(PageTreeCheckbox.Tooltips.HasChildren)"
    }
  },
  "PageTreeContent": {
    "HasDraftVersion": "Har utkastversion",
    "addSubPageButtonLabel": "Ny undersida",
    "edit": "Redigera",
    "editEventButtonLabel": "Redigera evenemang",
    "editPageButtonLabel": "Redigera sida",
    "missingDate": "Datum saknas",
    "movePagesHereButtonLabel": "Flytta valda sidor under denna"
  },
  "PageTreeFilter": {
    "ClearAllFiltersTooltip": "Rensa alla filter"
  },
  "PageTreeToolbar": {
    "MovePageToFolderDialog": {
      "Cancel": "Avbryt",
      "ConfirmMove": "Flytta",
      "Title": "Flytta till mapp"
    },
    "filterCategoriesButtonLabel": "Filtrera kategorier",
    "locations": "Platser",
    "noLocationsFound": "Inga platser hittades",
    "subCategoryLabel": "Kategori",
    "toggleLastEditedButtonLabel": "Senast ändrad",
    "toggleSelectionModeButtonLabel": "Välj flera"
  },
  "PreviewWrapper": {
    "PreviewMode": {
      "developer": "Utvecklare",
      "normal": "Normal"
    }
  },
  "ProgramBlock": {
    "AddProgramTime": "Lägg till programtid",
    "ProgramTimeItem": {
      "Description": "Beskrivning",
      "From": "Från",
      "ProgramTime": "Programtid",
      "RemoveProgramTimeItem": "Ta bort programtid",
      "Title": "Titel",
      "To": "Till"
    }
  },
  "QuoteBlock": {
    "byline": "Byline",
    "quote": "Citat"
  },
  "RadioInput": {
    "NoValue": "Ingen"
  },
  "SearchSelector": {
    "noMatch": "Ingen träff"
  },
  "SectionDirectionSelector": {
    "Tooltip": "Riktning",
    "options": {
      "carousel": "Karusell",
      "introbanners": "Beta: IntroBanners",
      "ltr": "Höger",
      "rtl": "Vänster",
      "snappy": "Beta: Snappy Banners"
    }
  },
  "SectionWidthSelector": {
    "Tooltip": "Bredd",
    "options": {
      "article__grid": "Smal",
      "full__grid": "Full (100%)",
      "section__grid": "Sidbredd",
      "wide__grid": "Bred"
    }
  },
  "SelectButton": {
    "Deselect": "Avmarkera",
    "Select": "Välj"
  },
  "SelectInput": {
    "NoSelection": "Ingen vald"
  },
  "SelectedDMMediaItem": {
    "License": "Licens",
    "Owner": "Ägare"
  },
  "Settings": {
    "LanguageSettings": {
      "404": {
        "404pageMissing": "404-sida saknas",
        "addPageButton": "Välj sida",
        "pagenotfoundInfoMessage": "Används endast om 404-sida saknas",
        "pagenotfoundText": "\"Sidan kunde inte hittas\"-text",
        "pagenotfoundTitle": "\"Sidan kunde inte hittas\"-titel",
        "title": "404 - Sidan kunde inte hittas"
      },
      "keypages": {
        "dmFilterPage": "DigitaltMuseum filter-sida",
        "dmFilterPageInfo": "Denna sida ska innehålla en DigitaltMuseum-filtermodul som är inställd för att visa sökresultat från DigitaltMuseum. Slutanvändaren återvänder till denna sida när hen söker via klick på platser, nyckelord osv. i en integrerad DigitaltMuseum fullvy."
      },
      "LanguageCreationView": {
        "description": "Kort beskrivning",
        "languagetext": "Språk",
        "languagetextPlaceholder": "Exempelvis \"Svenska\"",
        "name": "Namn på webbplatsen för detta språk"
      },
      "LanguageFooterSettings": {
        "address": "Adress",
        "addressLabel": "Ledtext",
        "addressTitle": "Adress",
        "addressesTitle": "Extra adresser",
        "copyright": "Copyright",
        "editor": "Ansvarig utgivare",
        "editorLabel": "Etikett för ansvarig utgivare",
        "email": "E-post",
        "emailLabel": "Etikett för e-post",
        "infoText": "Adresser och kontaktinfo i sidfoten hämtas från webbplatsinställningar, men kan åsidosättas här för översättningar.\nFler adressrader kan också läggas till.",
        "link": "Länk till information",
        "menu": {
          "cssClass": "CSS-klass",
          "includeNavPath": "Inkludera sökfält i sidfoten (använder sökinställningar från headern)",
          "includeSearchField": "Inkludera navigationsväg i sidfoten",
          "menuPointTitle": "Menypunktens titel",
          "subMenu": "Undermeny"
        },
        "menuTitle": "Meny",
        "name": "Namn",
        "openInNewWindow": "Öppna i nytt fönster/flik",
        "orgNumber": "Organisationsnummer",
        "orgNumberLabel": "Etikett för organisationsnummer",
        "phone": "Telefonnummer",
        "phoneLabel": "Etikett för telefon",
        "postalCode": "Postnummer",
        "postalPlace": "Postort",
        "privacyLink": "Länk till integritetspolicy",
        "privacyLinkLabel": "Text för länk till integritetspolicy",
        "privacySettingsLabel": "(KIT CCM) Endre integritetspolicy",
        "responsibleEditor": "Ansvarig redaktör",
        "responsibleEditorLabel": "Etikett för ansvarig redaktör",
        "transparencyActLink": "Länk till åpenhetsloven",
        "transparencyActLinkLabel": "Text för länk till åpenhetsloven",
        "social": {
          "facebook": "Facebook",
          "flickr": "Flickr",
          "instagram": "Instagram",
          "linkedin": "LinkedIn",
          "pinterest": "Pinterest",
          "textFieldLabel": "Text",
          "textFieldPlaceholder": "Besök oss på...",
          "tripadvisor": "TripAdvisor",
          "twitter": "Twitter",
          "vimeo": "Vimeo",
          "youtube": "YouTube",
          "tiktok": "TikTok"
        },
        "socialTitle": "Sociala medier",
        "text": "Fri text",
        "uuLink": "Länk till tillgänglighetsutlåtande",
        "uuLinkLabel": "Text för tillgänglighetsutlåtande"
      },
      "LanguageInfoSettings": {
        "defaultLanguage": "Ange som standardspråk",
        "pageInfo": {
          "description": "Kort beskrivning",
          "name": "Webbplatsens namn",
          "title": "Webbplatsinformation",
          "overrideLocale": "Åsidosätt språk-kod",
          "translations": "Diverse oversettelser",
          "KulturPunktLabel": "Kulturpunkt",
          "KulturPunktHitsLabel": "Kulturpunkt träffar"
        }
      },
      "LanguageLogoSettings": {
        "logoEcoLighthouse": "Logotyp Miljøfyrtårn",
        "logoEcoLighthouseLink": "Länk till Miljøfyrtårninfo",
        "logoConsolidatedFooter": "Logotyp för konsoliderat museum sidfot (SVG)",
        "logoConsolidatedHeader": "Logotyp för konsoliderat museum topp (SVG)",
        "logoFooter": "Logotyp sidfot (SVG)",
        "logoFooterGlobal": "Logotyp sidfot (SVG)(för alla språk)",
        "logoHeader": "Logotyp topp (SVG)",
        "logoHeaderGlobal": "Logotyp topp (SVG)(för alla språk)",
        "logoTitle": "Logotyptitel med stöd för radbrytning",
        "parentUrl": "Länk till gemensamt museum",
        "svgCode": "SVG-kod",
        "parentName": "Namn på konsoliderat museum",
        "parentText": "Text över logotypen"
      },
      "LanguageMenuSettings": {
        "addPageButton": "Välj sida",
        "availableLanguages": "Tillgängliga språk",
        "consolidatedInfo": "Konsoliderad information",
        "consolidatedLink": "Konsoliderad länk",
        "consolidatedLine": "Konsoliderad linjetext",
        "consolidatedLogo": "Konsoliderat logotyp (SVG)",
        "consolidatedName": "Namn på konsoliderat museum",
        "cssClass": "CSS-klass",
        "focusMenu": "Fokusmeny",
        "includeConsolidatedLine": "Visa konsoliderad linje",
        "includeConsolidatedLogo": "Visa konsoliderat logotyp",
        "includeInfoLine": "Visa infolinje",
        "infoLineFrontPageOnly": "Visa bara på startsidan",
        "includeLanguageMenu": "Visa språkval",
        "includeSearchButton": "Visa sökknapp i sökfältet",
        "includeSearchField": "Visa sökfält",
        "infoLine": "Info linje",
        "infoLineText": "Text i infolinje",
        "infoLineButtonText": "Text på infolinje-knapp/textlänk",
        "infoLineShowAsLink": "Visa som textlänk på alla skjermstorlekar",
        "infoLineLink": "Länk (url) i infolinje",
        "infoLineSkin": "Färg (skin) på infolinje",
        "languageMenu": "Språkval",
        "languageTitleInMenu": "Titel för språk i menyn",
        "languagesInMenu": "Språkval (i önskad ordning)",
        "mainMenu": "Huvudmeny",
        "menuPointTitle": "Menypunktens titel",
        "searchButtonText": "Text på sökknapp",
        "searchField": "Sökfält",
        "searchFieldText": "Text i sökfält",
        "searchresultPage": "Sökresultatsida",
        "subMenu": "Undermeny",
        "url": "URL"
      },
      "SEO": {
        "description": "SEO-beskrivning (meta-tag)",
        "keywords": "SEO-nyckelord (meta-tag)",
        "title": "Sökmotoroptimering",
        "enableSitemap": "Aktivera automatisk sitemap.xml för detta språk"
      },
      "childCount_one": "1 objekt",
      "childCount_other": "{{count}} objekt",
      "childCount_zero": "Inga objekt"
    },
    "SiteSettings": {
      "SiteCategoriesSettings": {
        "Info": {
          "Clarification": "Kategorier användes tidigare främst för att lätt kunna hämta sidor/kort automatiskt. Detta kan nu lösas med moduler för automatisk (och manuell) sidlistning, så de gamla kategorierna är nu överflödiga.",
          "Definition": "KATEGORIER är nu fördefinierade i Museum24 för att enklare kunna användas över flera webbplatser. Vissa kategorier har också underkategorier för bättre filtrering. \"Evenemang\" har också blivit en distinkt sidtyp.",
          "ReadMoreCategories": "Läs mer om kategorier",
          "ReadMoreEvents": "Läs mer om Evenemang som ny sidtyp",
          "ReadMorePageListing": "Läs mer om sidlistning"
        }
      },
      "SiteKeywordsSettings": {
        "deleteConfirm": "Är du säker på att du vill radera?",
        "displayOnlyUnused": "Visa endast oanvända nyckelord",
        "infoText": "Nyckelord kan skapas och kopplas till innehåll för att förenkla återanvändning och sökning, samt möjliggöra sökning för slutanvändare. Här kan du hantera nyckelord, ta bort sådana som inte ska användas eller rätta stavfel, dubbletter m.m. Nedan listas alla taggar som skapats för denna webbplats. När du skriver in en ny tagg ser du om denna redan finns i listan.",
        "newCardCategory": "Sök, eller lägg till ny kortkategori",
        "newKeyword": "Sök, eller lägg till nytt nyckelord",
        "sorting": "Sortering",
        "tag": "Nyckelord"
      },
      "SiteLocationsSettings": {
        "changeCoordinates": "Ändra koordinater",
        "deleteConfirmBody": "Är du säker på att du vill ta bort denna plats?",
        "deleteConfirmTitle": "Ta bort plats",
        "full_address": "Fullständig adress",
        "infoText": "Platser du skapar här kan återanvändas och kopplas till annat innehåll du vill ge en platsangivelse",
        "missingTitle": "Platsnamn saknas",
        "postal_code": "Postnummer",
        "postal_town": "Postort",
        "street_name": "Gatuadress",
        "titleInputLabel": "Namn på plats"
      },
      "SitePageTemplateSettings": {
        "deleteTemplateError": "Ett fel uppstod när mallen skulle tas bort",
        "deleteTemplateSuccess": "Mallen togs bort",
        "editTemplateButton": "Redigera mall",
        "infoText": "Mallar låter dig spara uppsättningen av en befintlig sida och snabbt skapa fler liknande sidor.",
        "readMoreLabel": "Läs mer om mallar här"
      },
      "SiteSharingSettings": {
        "Events": {
          "title": "Export av evenemang (JSON)",
          "intro": "URL:en nedan tillhandahåller denna webbplatss kommande evenemang (upp till ett år framåt) som JSON-data för import till andra tjänster. Dataformatet som vi erbjuder är specifikt utvecklat för export till Visit-tjänster i Norge (drivs av SimpleView). Om du vill exportera från flera webbplatser via samma URL måste du inkludera ID:n för dessa webbplatser kommaseparerade i URL:en via ?site_id=ID1,ID2,osv. Om du väljer ett annat språk för webbplatsen i språkväxlaren uppe till höger får du även en URL för att hämta evenemang på det språket."
        },
        "SharingContentType": {
          "content": "Innehåll (sidor, kort, evenemang, anställda)",
          "label": "Innehållstyp",
          "resources": "Media",
          "templates": "Mallar"
        },
        "SiteSharingSettingsNewAgreementModal": {
          "selectSite": "Välj webbplats",
          "titles": {
            "given": "Ge ny åtkomst till:",
            "granted": "Ansök om ny åtkomst till:"
          }
        },
        "accessToX": "Du har åtkomst till: ({{x}})",
        "addNewAccess": "Ny åtkomst",
        "addNewApplication": "Ny ansökan",
        "contentType": "Innehållstyp",
        "sharingWithX": "Du delar med: ({{x}})",
        "unsavedChanges": "Du har osparade ändringar! Tryck 'Spara' för att bekräfta ändringarna."
      }
    },
    "WebpageSettings": {
      "General": "Generelt",
      "SiteID": "Webbplats ID",
      "SiteName": "Webbplats namn och beskrivning",
      "SiteDefaultLanguage": "Standard språk",
      "SiteUrl": "Webbplatsens domän/URL",
      "WebpageEKulturIntegrationsSettings": {
        "title": "E-kultur integrasjoner",
        "digitaltMuseum": "DigitaltMuseum",
        "dmOwners": "DigitaltMuseum-ägarkoder",
        "dmIncludedInSiteSearch": "Visa treff fra DigitaltMuseum i webbplatssök",
        "dmIntegratedView": "Bruk integrert visning for DigitaltMuseum",
        "kulturPunkt": "KulturPunkt",
        "kulturpunktOwnerID": "Museum-ID",
        "kpComplete": "Vis hela KulturPunktet vid integrerad vy",
        "kulturpunktIncludedInSiteSearch": "Visa träffar från KulturPunkt i webbplatssök"
      },
      "WebpageIconsSettings": {
        "title": "Ikoner",
        "addFileButtonLabel": "Lägg till logofil",
        "favicon": "Favicon",
        "faviconCaption": "Litet bild-/ikonformat som visas i webbläsarfliken",
        "noImageChosen": "Ingen bild vald",
        "touchicon": "Webbplatsens touch-ikon",
        "touchiconCaption": "Ikon om någon skapar en genväg på sin smartphone",
        "otherIconSettings": "Andra ikoninstillningar",
        "disableEkulturMapPin": "Inte använda Ekulltur kartpins",
        "disableKPmapPin": "Inte använda KulturPunkt kartpins",
        "disableDMmapPin": "Inte använda DM kartpins"
      },
      "WebpageConsentSettings": {
        "title": "Samtyckeshantering",
        "gdprScripts": "Scripts från andra leverantörer (usersentric, cookiebot etc.)",
        "KitCMP": "Standard Ekultur samtyckeslösning (under utveckling!)",
        "KitCMPdescription": "Detta konfigureras via Ekultur's administrationslösning för samtyckeshantering per webbplats/museum. Lösningen kommer att vara tillgänglig för användning när den är helt utvecklad. Det är dock avsett som ett alternativ för dem som inte har andra lösningar för samtyckeshantering och inte använder externa analys- eller marknadsföringsverktyg som kräver samtycke.",
        "KitCMPisActive": "Lösningen är aktiverad för denna webbplats",
        "KitCMPisInactive": "Lösningen är inte aktiverad för denna webbplats",
        "activateKitCMP": "Aktivera Ekultur samtyckeslösning",
        "activateKitCMPbutton": "Vis flytande knapp for personverninnstillinger",
        "enableGdprInTestEnvironments": "Aktivera samtyckeslösning i testmiljø",
        "KitCMPTestScript": "TestScript (för att testa samtyckeslösningen medan den är under utveckling)",
        "OtherCMP": "Annan samtyckeslösning (Usercentric, Cookiebot etc.)",
        "OtherCMPDescription": "Om du redan har en samtyckeslösning som du vill använda kan KulturIT lägga till skript för detta här eller under språkinställningar (om olika skript för olika språk). En Google Consent Certified måste användas om du vill koppla externa statistik- och marknadsföringsverktyg (såsom Google Analytics, Google Tagmanager, Facebook Pixel etc.) till webbplatsen.",
        "OtherCMPscript": "Script för annan samtyckeshanteringsleverantör",
        "OtherCMPisActive": "Annan samtyckeslösning är aktiverad för denna webbplats"
      },
      "WebpageTrackingSettings": {
        "title": "Webbplatsanalys",
        "facebook": "Facebook",
        "facebookDomainVerification": "Facebook Domain Verify",
        "facebookDomainVerificationCaption": "Ange enbart din domänverifierings-ID",
        "facebookDomainVerificationPlaceholder": "T.ex. a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5",
        "facebookPixcelCode": "Facebook/Meta Pixel ID",
        "facebookPixcelCodeCaption": "Ange endast din pixelkod \"ID\"",
        "facebookPixcelCodePlaceholder": "T.ex. 123456789012345",
        "onlyKeysWarning": "Ange endast själva nyckeln/ID:t i dessa fält – aldrig skript eller kod (t.ex. <script>…</script> eller <meta …>). Kod som klistras in här fungerar inte och kan orsaka fel på webbplatsen.",
        "google": "Google",
        "googleGtagKey": "Google Analytics 4 Key",
        "googleMapsKey": "Karta: Google Maps Key",
        "googleMapsKeyPlaceholder": "AIzaSy… (om du har en egen nyckel för denna webbplats)",
        "googleSiteVerification": "Google Site Verification UID (Webmastertools)",
        "googleSiteVerificationCaption": "Ange endast värdet från content=\"…\" i meta-taggen som Google ger dig. Om den här metoden inte fungerar finns det andra sätt att verifiera webbplatsen – kontakta KulturIT.",
        "googleTagmanagerKey": "Google Tagmanager Key",
        "enableStructuredGoogleBreadcrumbs": "Aktivera Google-strukturerade data för brödsmulor",
        "enableStructuredGoogleEvents": "Aktivera Google-strukturerade data för händelser",
        "plausible": "Plausible (Standard för Museum24)",
        "plausibleDescription": "Standardanalys för webbplatser i Museum24",
        "plausibleEnable": "Slå på Plausible analys",
        "plausibleEnabled": "Plausible är aktiverat för denna webbplats",
        "plausibleNotEnabled": "Plausible är inte aktiverat för denna webbplats",
        "plausibleWebsiteId": "Plausible Website ID (om annat än domännamn)",
        "plausibleExtraTrackerId": "Plausible extra Tracker ID",
        "plausibleAuth": "Embed AUTH kod för Plausible (kan anges istället för plausibleEmbedUrl)",
        "plausibleScriptId": "Plausible Script ID (nytt opplegg for å inkludere script fra okt. 25)",
        "plausibleUniqueDomain": "Dersom ingen andra webbplats använder samma domännamn, kan du huka i rutan",
        "plausibleEnableLocalhostTracking": "Aktiver sporing på localhost (for testing lokalt)"
      },
      "WebpageSearchSettings": {
        "title": "Sök på flera webbplatser",
        "description": "Vilka webbplatser vill du kunna söka mot?",
        "availableSites": "Tillgängliga webbplatser baserat på delingsavtal",
        "search": "Sök"
      },
      "WebpageSystemSettings": {
        "title": "Systeminställningar",
        "description": "SScripts etc. Dessa inställningar är endast för administratörer och utvecklare. De påverkar hur webbplatsen fungerar i bakgrunden.",
        "gdprScripts": "GDPR scripts",
        "scripts": "Scripts/Styles (Header)",
        "footerScripts": "Scripts (At bottom)",
        "diverse": "Diverse inställningar",
        "cssClass": "CSS-klasser (body)",
        "siteIsNotAphysicalLocation": "Denna webbplats är inte en fysisk plats (visas inte vid evenemang)",
        "dmChannel": "Denna webbplats är en DigitaltMuseum-kanal"
      },
      "WebpageContactInfoSettings": {
        "title": "Kontaktinformation (språkuavhängigt)",
        "description": "Kontaktinformation som visas i footern. Kan åsidosättas i footerinställningar per språk."
      }
    },
    "titles": {
      "404": "404-sida",
      "categories": "Kategorier",
      "create": "Lägg till nytt språk",
      "eKulturIntegrations": "eKultur-integrationer",
      "footer": "Sidfot",
      "footerMenu": "Sidfotsmeny",
      "keypages": "Viktiga sidor",
      "keywords": "Nyckelord",
      "language": "Språk",
      "languageInfo": "Information",
      "locations": "Platser",
      "logo": "Logotyp",
      "menu": "Header / Meny",
      "seo": "SEO / Meta",
      "sharing": "Åtkomst och delning",
      "site": "Webbplatsinställningar",
      "tracking": "Spårning och länkar",
      "users": "Användare",
      "webpage": "Webbplatsinställningar",
      "webpageIcons": "Webbplatsikoner och logotyper",
      "webpageInfo": "Information om webbplats"
    }
  },
  "SiteSelector": {
    "selectOrChangeActiveSite": "Välj eller byt aktiv webbplats",
    "selectOrChangeActiveSiteLanguage": "Välj eller byt aktivt webbplatsspråk"
  },
  "SiteSharingBlockSettings": {
    "MuseumSharingInfo": "Saknas museer? Kontrollera delningsavtal",
    "SelectAll": "Välj alla",
    "SelectSites": "Välj museer att filtrera efter",
    "UnselectAll": "Avmarkera alla"
  },
  "SiteUsersSettings": {
    "name": "Namn",
    "email": "E-post",
    "role": "Roll"
  },
  "SkinSelector": {
    "SelectSkinTooltip": "Välj skins"
  },
  "SortMenu": {
    "Asc": "Stigande",
    "Date": "Senast ändrad",
    "Desc": "Fallande",
    "SortBy": "Sortera efter",
    "SortDirection": "Riktning",
    "SortMenuTooltip": "Sortera sidor",
    "Status": "Status",
    "Title": "Titel"
  },
  "TableBlock": {
    "AddRow": "Lägg till rad",
    "ColAsHeader": "Använd första kolumnen som rubrik",
    "ConfirmParseTable": "Är du säker på att du vill konvertera tabellen? Befintligt innehåll skrivs över.",
    "DisplayState": {
      "collapsed": "Komprimerad",
      "expanded": "Utökad"
    },
    "NoBorder": "Ingen kantlinje",
    "StripedHorizontal": "Randiga horisontella linjer",
    "FooterText": "Footer text",
    "HideInputField": "Dölj inmatningsfält för att kopiera och klistra in externa tabeller",
    "InitialStatePlaceholder": "Visningsläge",
    "InputFieldPlaceholder": "Kopiera och klistra in tabell från webbsida, kalkylark etc.",
    "NrOfColumns": "Antal kolumner",
    "ParseWithComma": "Skapa tabell med kommatecken som avgränsare",
    "ParseWithTab": "Skapa tabell med tab som avgränsare",
    "RowAsHeader": "Använd första raden som rubrik",
    "SelectInitialState": "Välj hur tabellen ska visas initialt",
    "ShowInputField": "Visa inmatningsfält för att kopiera och klistra in externa tabeller"
  },
  "TextBlock": {
    "SplitCancel": "Avbryt",
    "SplitHere": "Dela här",
    "SplitMode": "Dela modul",
    "SplitModeInfo": "Klicka i texten där modulen ska delas. Den röda linjen visar platsen, och allt i det skuggade fältet flyttas till en ny textmodul direkt nedanför. Titel, bild och länkar stannar här.",
    "SplitModeTooltip": "Dela modulen i två",
    "SplitNothingAfter": "Det finns ingen text efter markören. Flytta markören dit modulen ska delas.",
    "HideBodyText": "Dölj brödtext och visa den när titeln klickas",
    "IconHelpText": "Ikon visas endast i textruta-läge",
    "TextEditorType": "Byt texteditor",
    "TitleOverLinkList": "Titel över länklista",
    "localCaption": "Lokal bildtext",
    "localCaptionDescription": "Åsidosätter global bildtext"
  },
  "ToggleExpandAllButton": {
    "ContractAll": "Komprimera alla",
    "ExpandAll": "Expandera alla"
  },
  "ToggleSelectAllCheckbox": {
    "CountItemsSelected_one": "{{count}} sida vald",
    "CountItemsSelected_other": "{{count}} sidor valda",
    "DeselectAll": "Avmarkera alla",
    "SelectAll": "Välj alla"
  },
  "UserAvatarMenu": {
    "siteRole": "Ditt webbplatsroll är ",
    "logOut": "Logga ut",
    "ownerSettings": "Ägarinställningar ({{owner}})",
    "settings": "Sidinställningar ({{site}})"
  },
  "ViewTypeSelector": {
    "SelectViewTypeVariant": "Välj visningstyp",
    "SelectViewTypeWidth": "Välj bredd",
    "ViewTypeWidth": {
      "full": "Sidbredd",
      "narrow": "Mittenkolumn",
      "none": "Auto",
      "wide": "Bred"
    }
  },
  "WidgetBlock": {
    "height": "Iframe-höjd",
    "html": "HTML-kod (SVG, enkla HTML-taggar, tredjeparts JS-widgets)",
    "isWidget": "Detta är ett script/widget",
    "src": "Iframe SRC",
    "width": "Iframe-bredd",
    "iframeSettings": "Iframe-inställningar",
    "additionalSettings": "Ytterligare inställningar (alternativt innehåll)",
    "externalUrl": "Extern URL (visning hos 3.parts tjänst)",
    "widgetDescription": "Beskriv tjänsten med ett par ord",
    "convert": "Konvertera widget",
    "convertInfo": "Om widgeten används för tredjeparts ljud-/videotjänster (Soundcloud, Spotify, YouTube, etc.) kan du konvertera den här till en ny ljud-/videomodul. Detta kommer att organisera innehållet på webbplatsen mer exakt. Data i modulen kommer automatiskt att överföras till den nya modulen.",
    "convertConfirm": "Är du säker på att du vill konvertera denna widget?",
    "convertToAudio": "Konvertera till LJUD-modul",
    "convertToVideo": "Konvertera till VIDEO-modul",
    "securityInfo": "<strong>VIKTIGT:</strong> Här ska det ENDAST läggas in kod från säkra och verifierade källor och tredjepartsleverantörer. Om du är osäker på koden, kontakta KulturIT för bedömning och vägledning. KulturIT kommer också att genomföra regelbundna kontroller av innehållet i Widget-modulen för att bedöma säkerheten.<br/><br/>OBS! Museum24 har egna moduler för ljud och video, så använd dessa för ljud och video. Widget-modulen kan även enkelt konverteras till en ljud- eller videomodul. Se längst ned i modulen."
  },
  "AudioBlock": {
    "title": "Titel",
    "filename": "Filnamn",
    "source": "Ljudkälla",
    "sourceEkultur": "Ljud från Ekultur (Museum24, DigitaltMuseum)",
    "sourceExternal": "Extern ljudleverantör (Soundcloud, Spotify eller liknande)",
    "provider": "Ljudleverantör",
    "other": "Annat",
    "providerHelpText": "Välj en leverantör för ljudet. Om du inte kan hitta leverantören här, välj Annat och meddela KulturIT om detta.",
    "m24Sound": "Ljud från Museum24-galleriet",
    "pickM24Sound": "Plocka ljud från Museum24-galleriet",
    "pickDMSound": "Plocka ljud-objekt från DigitaltMuseum",
    "localTitle": "Lokal titel (om annan än objektets titel)",
    "localCaption": "Lokal beskrivning (om annan än objektets beskrivning)",
    "disableCredits": "Dölj credits",
    "securityInfo": "<strong>VIKTIGT:</strong> Här ska det ENDAST läggas in kod från säkra och verifierade källor och tredjepartsleverantörer. Välj leverantör från rullgardinsmenyn. Om du är osäker på koden, kontakta KulturIT för bedömning och vägledning."
  },
  "VideoBlock": {
    "source": "Videokälla",
    "sourceEkultur": "Video från Ekultur (Museum24, DigitaltMuseum)",
    "sourceExternal": "Extern videoleverantör (YouTube, Vimeo eller liknande)",
    "provider": "Videoleverantör",
    "other": "Annat",
    "providerHelpText": "Välj en leverantör för videon. Om du inte kan hitta leverantören här, välj Annat och meddela KulturIT om detta.",
    "m24Video": "Video från Museum24-galleriet",
    "pickM24Video": "Plocka video från Museum24-galleriet",
    "pickDMVideo": "Plocka video-objekt från DigitaltMuseum",
    "localTitle": "Lokal titel (om annan än objektets titel)",
    "localCaption": "Lokal beskrivning (om annan än objektets beskrivning)",
    "disableCredits": "Dölj credits"
  },
  "ReferencesBlock": {
    "addReference": "Lägg till referens/källa",
    "referenceLabel": "Referens/källa",
    "referencePlaceholder": "Skriv in referens här",
    "date": "År / Datum",
    "media": "Media (Tidskrift, tidning ev. uppsats)",
    "issue": "Utgåva (nr./år)",
    "pageNumber": "Sidanummer",
    "publisher": "örlag/Utgivare (ev. skola)",
    "place": "Plats",
    "author": "örfattare / Redaktör(er) / ID på dokument el.",
    "title": "Titel på arbeteet",
    "sitename": "Namn på webbplats",
    "url": "URL (om tillgänglig online)",
    "referenceType": "Typ av referens",
    "referenceNumber": "Referensnummer",
    "reportNumber": "Rapportnr",
    "referenceTypeOptions": {
      "article": "Artikel",
      "book": "Bok",
      "chapter": "Kapitel",
      "document": "Dokument",
      "film": "Film",
      "interview": "Intervju",
      "map": "Karta",
      "newspaper": "Tidning",
      "report": "Rapport",
      "website": "Webbplats",
      "other": "Annat"
    }
  },
  "common": {
    "setAsPageMainImage": "Använd som huvudbild för sidan"
  }
}
